/**
 * Archivo de localización: EN
 * Míster 11 - Sistema de Localización Canónico
 */

export const en = {
  "ach.biweekly_fit.desc": "Record or beat your personal best in team fitness tests.",
  "ach.biweekly_fit.name": "Physical Evolution",
  "ach.biweekly_iron.desc": "100% attendance during 14 consecutive days.",
  "ach.biweekly_iron.name": "Iron Player",
  "ach.biweekly_self_care.desc": "Submit your wellness check-in on at least 80% of days.",
  "ach.biweekly_self_care.name": "Healthy Habit",
  "ach.biweekly_strong_mind.desc": "Complete 3 psychological tests on coping or mental toughness.",
  "ach.biweekly_strong_mind.name": "Match Resilience",
  "ach.biweekly_teammate.desc": "Confirm your attendance (RSVP) to all events in advance.",
  "ach.biweekly_teammate.name": "Group Commitment",
  "ach.gold_cone_memory.desc": "Recall and reproduce a sequence of at least 6 cones in Cone Memory.",
  "ach.gold_cone_memory.name": "Championship Memory",
  "ach.gold_impulse_brake.desc": "Reach 90% or higher accuracy in the Impulse Brake game.",
  "ach.gold_impulse_brake.name": "Golden Brake",
  "ach.gold_tactical_eye.desc": "Score 5/5 correct answers in Tactical Eye by spotting the open teammate.",
  "ach.gold_tactical_eye.name": "Hawk Eye",
  "ach.season_analyst.desc": "Complete all questionnaires and evaluations in the catalog.",
  "ach.season_analyst.name": "Tactical & Mind Master",
  "ach.season_assist.desc": "Deliver decisive goal assists to your teammates.",
  "ach.season_assist.name": "Team Engine",
  "ach.season_captain.desc": "100% attendance at trainings and matches for a full month.",
  "ach.season_captain.name": "Captain Spirit",
  "ach.season_mental_squad.desc": "Team achievement: the squad accumulates 20 or more completed cognitive sessions.",
  "ach.season_mental_squad.name": "Mental Squad",
  "ach.season_scorer.desc": "Reach the target goal tally in official matches.",
  "ach.season_scorer.name": "Season Top Scorer",
  "ach.season_unstoppable.desc": "Maintain an active 21-day consistency streak.",
  "ach.season_unstoppable.name": "Unstoppable Streak",
  "ach.season_veteran.desc": "Participate or get called up in at least 80% of season matches.",
  "ach.season_veteran.name": "Season Veteran",
  "ach.weekly_attentive.desc": "Check match and training details before the call-up time.",
  "ach.weekly_attentive.name": "Always Ready",
  "ach.weekly_committed.desc": "Complete the assigned exercises from your individual plan.",
  "ach.weekly_committed.name": "Invisible Work",
  "ach.weekly_mind_active.desc": "Complete at least 3 cognitive training sessions or challenges this week.",
  "ach.weekly_mind_active.name": "Active Mind",
  "ach.weekly_perfect_week.desc": "Attend 100% of the training sessions scheduled for this week.",
  "ach.weekly_perfect_week.name": "Perfect Week",
  "ach.weekly_scholar.desc": "Complete at least 1 psychological test or evaluation in the portal.",
  "ach.weekly_scholar.name": "Strong Mind",
  "ach.weekly_wellness.desc": "Record your sleep and soreness on training days.",
  "ach.weekly_wellness.name": "Health Check-in",
  "ach.weekly_zen.desc": "Complete 4-4 Breathing on at least 3 different days during the week.",
  "ach.weekly_zen.name": "Zen",
  "achievements.toast_unlocked": "Achievement unlocked: {name}! (+{xp} XP)",
  "admin.account_deleted": "Your coach account and data have been deleted successfully.",
  "admin.ai.desc": "Configure Groq API key so Generative AI works across all devices (including tablet APK without recompiling).",
  "admin.ai.keyLabel": "Groq API Key (gsk_...)",
  "admin.ai.saveKey": "SAVE KEY",
  "admin.ai.title": "AI Configuration (Groq)",
  "admin.already_latest": "✅ You already have the latest version installed (v{version}).",
  "admin.apk.desc": "Install Mister11 directly on your Android tablet",
  "admin.apk.downloadBtn": "DOWNLOAD APK",
  "admin.apk.instructions": "Android only · Enable 'Unknown sources' in system settings before installing",
  "admin.apk.title": "Android Application (APK)",
  "admin.apk_download_done": "✅ Download complete. Find the file in your Downloads folder and install it.",
  "admin.apk_download_fallback": "⚠️ Direct download failed. Opening alternative link...",
  "admin.apk_download_start": "⬇️ Starting APK download...",
  "admin.backup_error": "Error generating backup.",
  "admin.groq_api_error": "Error saving API key to Firestore.",
  "admin.groq_api_saved": "Groq API Key saved successfully!",
  "admin.lang.title": "System Language",
  "admin.manageSubAndroidMsg": "Manage your subscription from mister11.app",
  "admin.match_not_found": "Match not found.",
  "admin.no_active_team": "No active team selected.",
  "admin.no_players": "No players in active team.",
  "admin.notif.title": "Notifications",
  "admin.pref.checkUpdates": "Check for updates",
  "admin.pref.checking": "Checking...",
  "admin.pref.darkMode": "Dark Mode",
  "admin.pref.reminders": "Session Reminders",
  "admin.pref.remindersDescApk": "Available on Android application (APK).",
  "admin.pref.remindersDescNative": "You will receive a notification 1 hour before each training session.",
  "admin.pref.systemLang": "SYSTEM LANGUAGE",
  "admin.pref.title": "Preferences",
  "admin.pref.version": "Current app version",
  "admin.profile_error": "Error saving profile.",
  "admin.profile_synced": "Coach profile synced across the entire system.",
  "admin.report_error": "Error generating global report.",
  "admin.section.equipos": "Team Management",
  "admin.select_match_first": "Please select a match first.",
  "admin.select_session_first": "Please select a session first.",
  "admin.select_team_first": "Please select a team first.",
  "admin.session_not_found": "Session not found.",
  "admin.settings.category": "CATEGORY",
  "admin.settings.coachProfile": "Coach Profile",
  "admin.settings.cookies": "Cookies",
  "admin.settings.copyConsentBtn": "🔗 Copy Digital Consent Link",
  "admin.settings.deleteAccountGdpr": "Delete Account & Data (GDPR)",
  "admin.settings.downloadConsentBtn": "Download Parental Consent (Printable)",
  "admin.settings.fullName": "Full Name",
  "admin.settings.inviteStaffBtn": "Copy / Share Link to Invite Coaches",
  "admin.settings.legalDesc": "Download required legal templates and manage informed consent for the parents of minor players.",
  "admin.settings.legalTitle": "Legal & Consent Center",
  "admin.settings.manageStaffBtn": "View and Manage Coaching Staff",
  "admin.settings.primaryColor": "PRIMARY COLOR",
  "admin.settings.privacy": "Privacy",
  "admin.settings.roleAnalyst": "Tactical Analyst",
  "admin.settings.roleAssistant3": "Assistant / 3rd Coach",
  "admin.settings.roleAssistantCoach": "Assistant Coach",
  "admin.settings.roleFitnessCoach": "Fitness Coach",
  "admin.settings.roleHeadCoach": "Head Coach (Admin)",
  "admin.settings.rolePhysio": "Physiotherapist / Doctor",
  "admin.settings.rolePlayer": "Player",
  "admin.settings.roleSpecialty": "Role / Specialty in Team",
  "admin.settings.saveIdentity": "SAVE Identity",
  "admin.settings.saveProfile": "SAVE Profile & Role",
  "admin.settings.season": "SEASON",
  "admin.settings.secondaryColor": "SECONDARY COLOR",
  "admin.settings.subtitle": "Customize your experience and the visual identity of your club.",
  "admin.settings.teamBadge": "TEAM CREST / BADGE",
  "admin.settings.teamIdentity": "Team Identity",
  "admin.settings.teamName": "TEAM NAME",
  "admin.settings.terms": "Terms",
  "admin.settings.title": "System Settings",
  "admin.settings.uploadImage": "Upload Image",
  "admin.shield_error": "Could not upload or process the image.",
  "admin.shield_saved": "Shield saved and optimized successfully!",
  "admin.svg_shield_saved": "Vector SVG shield saved successfully!",
  "admin.tab.ajustes": "Settings",
  "admin.tab.club": "Club",
  "admin.tab.ejercicios": "Exercises",
  "admin.tab.equipos": "Teams",
  "admin.tab.exportar": "Export",
  "admin.tab.general": "General",
  "admin.tab.suscripcion": "Subscription",
  "admin.team_identity_error": "Error updating team identity.",
  "admin.team_identity_updated": "Team identity updated successfully.",
  "admin.theme.dark": "Dark Mode",
  "admin.title": "Admin Dashboard",
  "admin.update_check_error": "Could not check for updates.",
  "admin.update_connect_error": "Error connecting to the server.",
  "admin.xp.absent": "Absent XP",
  "admin.xp.desc": "Configure XP points awarded per confirmed attendance status and team season goals.",
  "admin.xp.excused": "Excused XP",
  "admin.xp.goals": "Season Goals Target",
  "admin.xp.late": "Late XP",
  "admin.xp.present": "Present XP",
  "admin.xp.saveBtn": "XP Settings",
  "admin.xp.title": "Season & Differentiated XP Table",
  "admin.xp.veteran": "% Veteran Matches",
  "admin.xp_error": "Error saving XP configuration.",
  "admin.xp_saved": "XP table and season objectives saved successfully.",
  "analisis.btnExportPdf": "Export Analysis PDF",
  "analisis.chart.axisCounterEff": "Counter Efficiency",
  "analisis.chart.axisDuels": "% Duels",
  "analisis.chart.axisLossControl": "Loss Control",
  "analisis.chart.axisRecoveries": "Recoveries",
  "analisis.chart.axisShots": "Shots on Target",
  "analisis.chart.bars": "Direct Event Comparison",
  "analisis.chart.duels": "% Duels Won",
  "analisis.chart.losses": "Losses",
  "analisis.chart.radar": "Average Tactical Profile Radar",
  "analisis.chart.recoveries": "Recoveries",
  "analisis.chart.shotsOwn": "Own Shots",
  "analisis.chart.shotsOwnTitle": "Own Shots on Target",
  "analisis.chart.shotsRival": "Opponent Shots",
  "analisis.chart.trend": "Performance Evolution and Trend",
  "analisis.exportPdf": "Download PDF Analysis",
  "analisis.exportingPdf": "Generating PDF...",
  "analisis.kpi.counters": "Counterattack Efficiency",
  "analisis.kpi.countersSub": "Recovery conversion ratio",
  "analisis.kpi.duels": "Duels Won",
  "analisis.kpi.duelsSub": "Global duel success rate",
  "analisis.kpi.recLossSubAvg": "Avg. Rec / Losses",
  "analisis.kpi.recLossSubTot": "Total Rec / Losses",
  "analisis.kpi.recoveries": "Recoveries / Losses",
  "analisis.kpi.recoveriesSub": "Avg. Rec / Losses",
  "analisis.kpi.recoveriesSubTotal": "Total Rec / Losses",
  "analisis.kpi.shots": "Shots on Target",
  "analisis.kpi.shotsSub": "Avg. Own vs Opponent",
  "analisis.kpi.shotsSubAvg": "Avg. Own vs Opponent",
  "analisis.kpi.shotsSubTot": "Total Own vs Opponent",
  "analisis.kpi.shotsSubTotal": "Total Own vs Opponent",
  "analisis.loadingData": "Loading match events...",
  "analisis.modal.all": "All",
  "analisis.modal.clear": "Clear",
  "analisis.modal.confirm": "ACCEPT AND COMPARE",
  "analisis.modal.noDate": "No date",
  "analisis.modal.pending": "Pending",
  "analisis.modal.selectedCount": "{count} matches selected",
  "analisis.modal.title": "Select Matches to Compare",
  "analisis.modal.withData": "With data",
  "analisis.mode.averages": "Averages",
  "analisis.mode.title": "Metrics:",
  "analisis.mode.totals": "Totals",
  "analisis.noMatchesSelected": "Select at least 1 match to perform comparative analysis",
  "analisis.selectMatches": "Select Matches",
  "analisis.shortcuts.allSeason": "All Season",
  "analisis.shortcuts.last3": "Last 3",
  "analisis.shortcuts.last5": "Last 5",
  "analisis.shortcuts.title": "SHORTCUTS:",
  "analisis.subtitle": "Tactical evolution, shots, duels and recoveries throughout the season",
  "analisis.table.cards": "Cards (Y / R)",
  "analisis.table.duels": "Duels %",
  "analisis.table.fouls": "Fouls (F / A)",
  "analisis.table.match": "Match / Opponent",
  "analisis.table.recLoss": "Rec / Loss",
  "analisis.table.result": "Result",
  "analisis.table.shots": "Shots (O / R)",
  "analisis.table.title": "Detailed Breakdown by Match",
  "analisis.title": "Comparative Multi-Match Analysis",
  "app.copyright": "2026 Mister11 · {slogan}",
  "app.slogan": "The bench in your pocket",
  "attendance.banner.closeMatchSheet": "Close Match Sheet",
  "attendance.banner.completeSession": "📋 Complete Session",
  "attendance.banner.unclosedEvents": "You have {sessions} unrecorded session{sPlural} and {matches} match{mPlural} with open sheet.",
  "attendance.banner.unclosedSubtitle": "Complete attendance and close match sheets to finalize official attendance % and player minutes.",
  "attendance.btn.exportPdf": "📄 Export PDF",
  "attendance.callup.activeWindow": "Active Evaluation Window",
  "attendance.callup.consider": "Consider",
  "attendance.callup.notRecommended": "Not recommended",
  "attendance.callup.recommended": "Recommended",
  "attendance.callup.subtitle": "Real attendance metrics over scheduled sessions to guide your next match roster.",
  "attendance.callup.thBreakdown": "Breakdown (P / L / J / A / NR)",
  "attendance.callup.thGuidance": "Guidance",
  "attendance.callup.thPct": "% Window",
  "attendance.callup.thPlayer": "Player",
  "attendance.callup.thStreak": "🔥 Streak",
  "attendance.callup.title": "🎯 Call-up Attendance Assistant",
  "attendance.callup.window.biweekly": "Last 14 Days",
  "attendance.callup.window.microcycle": "Microcycle",
  "attendance.callup.window.season": "Season",
  "attendance.callup.window.week": "Current Week",
  "attendance.chart.filtersTitle": "Series Filters & Explanations (Click to Show/Hide)",
  "attendance.chart.guide.example": "Currently your team averages {avg}% attendance across {count} recorded events.",
  "attendance.chart.guide.step1": "1. Each point is a training or match: ordered chronologically.",
  "attendance.chart.guide.step2": "2. The green line is your attendance: above 70% you are on track.",
  "attendance.chart.guide.step3": "3. If red rises while green drops: there is a commitment issue to address.",
  "attendance.chart.guide.step4": "4. Tap any point to view details and open its register directly.",
  "attendance.chart.guide.title": "How to interpret this chart?",
  "attendance.chart.guideCoach": "Guide for Coaches (Simple Terms)",
  "attendance.chart.guideStep1": "1. Timeline & Events",
  "attendance.chart.guideStep2": "2. Green Line",
  "attendance.chart.guideStep3": "3. Warning Cross",
  "attendance.chart.guideStep4": "4. Interactive Detail",
  "attendance.chart.legend.absent": "Absent",
  "attendance.chart.legend.absent.desc": "Unexcused absences. Should aim for zero.",
  "attendance.chart.legend.attendance": "Actual Attendance (P+L)",
  "attendance.chart.legend.attendance.desc": "Players who attended (present + late). The higher, the better.",
  "attendance.chart.legend.justified": "Justified",
  "attendance.chart.legend.justified.desc": "Justified notices. Does not penalize the main %.",
  "attendance.chart.legend.late": "Late",
  "attendance.chart.legend.late.desc": "Late arrivals. Watch if it rises over several weeks.",
  "attendance.chart.legend.official": "Official (closed sheet/session)",
  "attendance.chart.legend.provisional": "Provisional (open sheet/session)",
  "attendance.chart.legend.threshold70": "Alert threshold (70%): below this, callup risk.",
  "attendance.chart.noData": "No attendance sessions or matches recorded yet.",
  "attendance.chart.openRegister": "Open Attendance Register",
  "attendance.chart.summaryStats": "Selected Event Summary",
  "attendance.chart.title": "Team Attendance Evolution",
  "attendance.markAllPresent": "Mark All Present",
  "attendance.register.closingSheet": "Closing Sheet...",
  "attendance.register.customNew": "+ New Custom Attendance Date",
  "attendance.register.date": "Date",
  "attendance.register.excludeTitle": "Excludes this session from attendance calculation for the entire squad",
  "attendance.register.expected": "⚽ Expected: {attended} of {total}",
  "attendance.register.extraSession": "Extra Session",
  "attendance.register.futureSession": "🕐 Future session",
  "attendance.register.markAllPresent": "Mark All Present",
  "attendance.register.markSuspended": "Mark Suspended",
  "attendance.register.matchSheetClosed": "📋 Official Match Sheet Closed",
  "attendance.register.matchSheetOpen": "⏳ Match Sheet Open",
  "attendance.register.officialNote": "✅ Official · confirmed by staff",
  "attendance.register.officialSaved": "✅ Official record saved",
  "attendance.register.pendingRegistration": "⏳ Pending registration",
  "attendance.register.prefillRsvp": "⚡ Pre-fill from RSVP",
  "attendance.register.prefillTooltip": "Pre-fill from player RSVP responses (manual edits preserved)",
  "attendance.register.provisionalNote": "⏳ Provisional · per player response (tap to confirm)",
  "attendance.register.reopenSheet": "🔓 Reopen Match Sheet",
  "attendance.register.rsvpLiveTitle": "📲 Player RSVP Responses & Planning (live)",
  "attendance.register.saveAndCloseSheet": "Save & Close Match Sheet",
  "attendance.register.saveAttendance": "Save Attendance",
  "attendance.register.selectEvent": "Select Training Session or Match:",
  "attendance.register.sessionsAndMatches": "Sessions and Matches",
  "attendance.register.suspendedActive": "Suspended (Active)",
  "attendance.register.suspendedSession": "🌧️ Suspended Session",
  "attendance.register.title": "Title",
  "attendance.register.updateNotice": "ℹ️ You can update attendance anytime; updates instantly",
  "attendance.rsvp.going": "Will come",
  "attendance.rsvp.justified": "Justified",
  "attendance.rsvp.late": "Coming late",
  "attendance.rsvp.none": "No reply",
  "attendance.rsvp.not_going": "Won't come",
  "attendance.saveBtn": "Save Attendance",
  "attendance.saveError": "Error saving attendance. Please try again.",
  "attendance.saveSuccess": "Attendance saved successfully.",
  "attendance.saving": "Saving...",
  "attendance.status.absent": "Absent",
  "attendance.status.injured": "Injured",
  "attendance.status.justified": "Justified",
  "attendance.status.late": "Late",
  "attendance.status.present": "Present",
  "attendance.status.unmarked": "Unmarked",
  "attendance.summary.acceptable": "✓ Acceptable",
  "attendance.summary.noData": "⚪ No data",
  "attendance.summary.optimal": "✓ Optimal",
  "attendance.summary.risk": "⚠️ Risk",
  "attendance.summary.sortBy": "Sort by:",
  "attendance.summary.sortName": "Name",
  "attendance.summary.sortNumber": "Number",
  "attendance.summary.sortPctAsc": "% Attendance (Low to High)",
  "attendance.summary.sortPctDesc": "% Attendance (High to Low)",
  "attendance.summary.thAbsent": "Absent",
  "attendance.summary.thAttendance": "% Attendance",
  "attendance.summary.thInjured": "Injured",
  "attendance.summary.thJustified": "Justif.",
  "attendance.summary.thLate": "Late",
  "attendance.summary.thNoRecord": "NR",
  "attendance.summary.thPresent": "Present",
  "attendance.summary.thStatus": "Status",
  "attendance.summary.threshold": "Alert Threshold:",
  "attendance.summary.title": "👥 Squad Attendance Summary ({count} players)",
  "attendance.tab.callup": "🎯 Call-up Assistant",
  "attendance.tab.register": "📋 Register Session",
  "attendance.tab.summary": "📊 Squad Summary",
  "attendance.tab.trend": "📈 Attendance Trend",
  "attendance.toast.allMarkedPresent": "All marked as present (Official)",
  "attendance.toast.errorClosing": "Error closing match sheet",
  "attendance.toast.errorReopening": "Error reopening match sheet",
  "attendance.toast.errorSaving": "Error saving attendance",
  "attendance.toast.noResponses": "No player responses yet",
  "attendance.toast.savedSuccess": "Attendance saved successfully",
  "attendance.toast.selectFirst": "Select a session or match first",
  "attendance.toast.sheetClosed": "Match sheet closed and minutes calculated",
  "attendance.toast.sheetReopened": "Match sheet reopened for editing",
  "attendance.toast.suspendedSaved": "Session marked as suspended and saved",
  "auth.coachRole": "I am Coach / Staff",
  "auth.email": "Email address",
  "auth.forgotPass": "Forgot password?",
  "auth.googleBtn": "Continue with Google",
  "auth.hasAccount": "Already have an account?",
  "auth.joinBtn": "Send Request",
  "auth.joinTeam": "Join a Team",
  "auth.loginBtn": "Enter Mister11",
  "auth.loginLink": "Log in",
  "auth.loginTitle": "Sign In",
  "auth.logout": "Log Out",
  "auth.noAccount": "Don't have an account?",
  "auth.parentRole": "I am Parent / Guardian",
  "auth.password": "Password",
  "auth.playerRole": "I am Player",
  "auth.registerLink": "Sign up for free",
  "auth.registerTitle": "Create Account",
  "auth.switched_coach": "Switched to Coach Mode",
  "auth.switched_player": "Switched to Player Portal",
  "auth.teamCode": "Invitation Code (6 digits)",
  "block.abp": "Set Pieces",
  "block.physical": "Physical",
  "block.tactical": "Tactical",
  "block.technical": "Technical",
  "block.warmup": "Warm-up",
  "board.actions.delete": "CLEAR",
  "board.actions.hideRival": "👁 HIDE OPPONENT",
  "board.actions.showRival": "👁 SHOW OPPONENT",
  "board.actions.title": "ACTIONS",
  "board.export.encodingProgress": "Encoding MP4 video...",
  "board.export.encodingTitle": "Exporting MP4 Video",
  "board.exportModal.btnCancel": "CANCEL",
  "board.exportModal.btnDownload": "DOWNLOAD",
  "board.exportModal.btnExport": "EXPORT",
  "board.exportModal.btnReset": "Reset framing",
  "board.exportModal.btnShare": "SHARE",
  "board.exportModal.closeModal": "Close modal",
  "board.exportModal.completedDesc": "The file has been processed and saved successfully.",
  "board.exportModal.completedTitle": "Export Completed!",
  "board.exportModal.exportPath": "Destination path",
  "board.exportModal.failed": "Error during export. Click to retry.",
  "board.exportModal.format": "Export Format",
  "board.exportModal.framingTitle": "Framing & Preview",
  "board.exportModal.landscape": "Horizontal (Landscape)",
  "board.exportModal.loadingPreview": "Loading animation preview...",
  "board.exportModal.metaDuration": "Estimated duration",
  "board.exportModal.metaSize": "Estimated size",
  "board.exportModal.metaTitle": "File title",
  "board.exportModal.oneFrame": "1 Frame",
  "board.exportModal.orientation": "Orientation",
  "board.exportModal.portrait": "Vertical (Portrait)",
  "board.exportModal.preparing": "Preparing frames to render...",
  "board.exportModal.quality": "Quality / Resolution",
  "board.exportModal.shared": "Shared!",
  "board.exportModal.speed": "Playback Speed",
  "board.exportModal.subtitle": "Configure export parameters and preview frame framing",
  "board.exportModal.title": "Export Tactical Animation",
  "board.exportModal.zoomIn": "Zoom in",
  "board.exportModal.zoomOut": "Zoom out",
  "board.fields.blank": "Blank Canvas",
  "board.fields.f7": "7-a-side (65x45m)",
  "board.fields.f8": "8-a-side (62x46m)",
  "board.fields.full": "Full Pitch",
  "board.fields.futsal": "Futsal (40x20m)",
  "board.fields.halfAttack": "½ Attack",
  "board.fields.halfDefense": "½ Defense",
  "board.fields.penaltyArea": "Penalty Box",
  "board.fields.reduced": "Small Sided Pitch",
  "board.fields.thirdAttack": "Attacking Third",
  "board.fields.thirdDefense": "Defensive Third",
  "board.fields.thirdMid": "Middle Third",
  "board.mat.aro": "Agility Ring",
  "board.mat.balon": "Football",
  "board.mat.balon_movimiento": "Moving Ball",
  "board.mat.balon_negro": "Black Ball",
  "board.mat.banderin": "Corner Flag",
  "board.mat.cono": "Cone",
  "board.mat.cono_amarillo": "Yellow Cone",
  "board.mat.cono_negro": "Black Cone",
  "board.mat.cono_rojo": "Red Cone",
  "board.mat.escalera": "Agility Ladder",
  "board.mat.flecha_ataque_h": "Horizontal Arrow",
  "board.mat.flecha_ataque_v": "Vertical Arrow",
  "board.mat.grupo_balones": "Ball Rack",
  "board.mat.grupo_conos": "Group of 3 Cones",
  "board.mat.grupo_conos_arco": "Arc of 5 Cones",
  "board.mat.grupo_conos_linea": "Line of 5 Cones",
  "board.mat.indicador_espacio": "Space Indicator",
  "board.mat.jugador_camiseta": "Jersey Player",
  "board.mat.jugador_triangulo": "Triangle Player",
  "board.mat.linea_distancia": "Distance Line",
  "board.mat.mini_cono": "Mini Cone",
  "board.mat.pared_rebote": "Rebound Wall",
  "board.mat.peto": "Training Bib",
  "board.mat.pica": "Agility Pole",
  "board.mat.platillo": "Disc Cone",
  "board.mat.porteria_grande": "Full Goal",
  "board.mat.porteria_lateral": "Side Goal",
  "board.mat.porteria_pequena": "Mini Goal",
  "board.mat.poste": "Post / Dummy",
  "board.mat.valla": "Hurdle",
  "board.mat.zona_circular": "Circular Zone",
  "board.mat.zona_grid": "Grid 3x3",
  "board.mat.zona_rectangular": "Rectangular Zone",
  "board.mat.zona_rombo": "Diamond Zone",
  "board.mat.zona_triangular": "Triangular Zone",
  "board.matCat.balon": "BALLS",
  "board.matCat.coordinacion": "AGILITY & FITNESS",
  "board.matCat.jugadores": "PLAYERS",
  "board.matCat.material": "EQUIPMENT",
  "board.matCat.medidas": "MEASUREMENTS",
  "board.matCat.porteria": "GOALS",
  "board.matCat.señalizacion": "MARKERS & CONES",
  "board.matCat.zonas": "ZONES",
  "board.panels.materials": "Equipment",
  "board.panels.teams": "Teams",
  "board.panels.teamsAndFormations": "Teams & Formations",
  "board.stroke.fine": "Thin",
  "board.stroke.medium": "Medium",
  "board.stroke.thick": "Thick",
  "board.teams.apply": "APPLY",
  "board.teams.local": "Starters",
  "board.teams.rival": "Opponent",
  "board.teams.title": "TEAMS",
  "board.teams.wildcard": "Neutral",
  "board.timeline.addFrame": "Add frame",
  "board.timeline.deleteFrame": "Delete frame",
  "board.timeline.export": "Export",
  "board.timeline.exportAnimation": "Export animation",
  "board.timeline.firstFrame": "First frame",
  "board.timeline.frameLabel": "Frame",
  "board.timeline.lastFrame": "Last frame",
  "board.timeline.nextFrame": "Next frame",
  "board.timeline.play": "Play",
  "board.timeline.playAria": "Play animation",
  "board.timeline.prevFrame": "Previous frame",
  "board.timeline.stop": "Stop",
  "board.timeline.stopAria": "Stop playback",
  "board.tool.straight_dashed_line": "Straight dashed line",
  "board.tool.zone_hexagon": "Hexagon zone",
  "board.tool.zone_pentagon": "Pentagon zone",
  "board.toolbar.clearCanvas": "Clear entire canvas",
  "board.toolbar.exportMp4": "EXPORT MP4",
  "board.toolbar.exportingMp4": "REC... EXPORTING MP4",
  "board.toolbar.fieldType": "Pitch type",
  "board.toolbar.fullscreen": "Full Screen",
  "board.toolbar.height": "Height",
  "board.toolbar.new": "NEW",
  "board.toolbar.redo": "Redo",
  "board.toolbar.resetZoom": "Reset Zoom",
  "board.toolbar.save": "SAVE",
  "board.toolbar.sides": "Sides",
  "board.toolbar.strokeColor": "Stroke Color",
  "board.toolbar.strokeWidth": "Stroke Width",
  "board.toolbar.swapSides": "Swap team sides",
  "board.toolbar.undo": "Undo",
  "board.toolbar.width": "Width",
  "board.toolbar.zoomIn": "Zoom In",
  "board.toolbar.zoomOut": "Zoom Out",
  "bottomnav.admin": "Admin",
  "bottomnav.ajustes": "Settings",
  "bottomnav.equipo": "Team",
  "bottomnav.home": "Home",
  "bottomnav.ia": "AI",
  "bottomnav.more": "More",
  "bottomnav.moreModules": "Modules & Management",
  "bottomnav.partidos": "Matches",
  "bottomnav.pizarra": "Board",
  "bottomnav.planificacion": "Planning",
  "bottomnav.sesiones": "Sessions",
  "bottomnav.tests": "Tests",
  "btn.add": "ADD",
  "btn.back": "BACK",
  "btn.cancel": "CANCEL",
  "btn.close": "CLOSE",
  "btn.confirm": "CONFIRM",
  "btn.delete": "DELETE",
  "btn.deleteAccount": "Delete Account & Data (GDPR)",
  "btn.edit": "EDIT",
  "btn.export": "EXPORT PDF",
  "btn.filter": "FILTER",
  "btn.save": "SAVE",
  "btn.search": "SEARCH",
  "capture.criteria.downloadPdf": "Download Official PDF",
  "capture.criteria.search": "Search criterion...",
  "capture.criteria.title": "Capture Criteria Manual",
  "capture.hud.advanced": "Advanced",
  "capture.hud.duel_lost": "Duel Lost",
  "capture.hud.duel_won": "Duel Won",
  "capture.hud.foul": "Foul",
  "capture.hud.key_pass": "Key Pass",
  "capture.hud.recovery": "Recovery",
  "capture.hud.shot": "Shot",
  "capture.hud.turnover": "Turnover",
  "capture.hud.unattributed": "Unattributed",
  "capture.refine_btn": "Refine attribution",
  "capture.refine_empty": "Nothing pending ✅",
  "capture.refine_prompt_title": "Refine individual attribution now? (optional)",
  "capture.refine_skip": "Skip",
  "capture.refine_subtitle": "Team totals are already computed. Assign only what you want to reflect on ratings, radars, and XP.",
  "capture.refine_title": "Refine individual attribution (optional)",
  "capture.team.shot_own": "Own Shot",
  "capture.team.shot_rival": "Opponent Shot",
  "charts.guide.bars": "Quantitative comparison of the 10 key gameplay metrics.",
  "charts.guide.momentum": "Evolution of match dominance and control in 15-minute intervals.",
  "charts.guide.radar": "Visualizes tactical balance across 6 dimensions between own team and opponent.",
  "charts.guide.shots": "Shot distribution and expected goals (xG) probability model.",
  "charts.guide.zones": "Territorial distribution of team interventions across 9 pitch zones.",
  "charts.insights.defensive_alert": "Defensive Alert: Opponent generated clear chances with high shooting comfort.",
  "charts.insights.dominant_zone": "Dominant Zone: Over 40% of actions concentrated in this area.",
  "charts.insights.finishing_deficit": "Finishing Efficiency: High volume of scoring chances with deficit in conversion vs generated xG.",
  "charts.pass_insufficient_tooltip": "At least 5 recorded passes required to generate tactical pass network.",
  "charts.view.pass_network": "Pass Network",
  "charts.view.territorial_map": "Territorial Map",
  "chat.notif_from_player": "💬 Message from {playerName}: \"{msgText}\"",
  "club.team_create_error": "Error creating club team.",
  "club.team_created": "Club team created successfully.",
  "club.teams_assign_error": "Error assigning teams.",
  "club.teams_assigned": "Teams assigned successfully.",
  "cognitive.active_challenges_title": "Active Recommended Challenges & Games ({count}):",
  "cognitive.assign_error": "Error saving assignments",
  "cognitive.assigned_success": "✔ {count} recommendation(s) assigned successfully",
  "cognitive.btn_recommend_challenge": "Recommend Challenge",
  "cognitive.btn_verified": "✔ Verified (+5 XP)",
  "cognitive.btn_verifying": "Verifying…",
  "cognitive.cat.alevin": "U-12",
  "cognitive.cat.benjamin": "U-10",
  "cognitive.cat.cadete": "U-16",
  "cognitive.cat.infantil": "U-14",
  "cognitive.cat.juvenil_adulto": "Youth / Senior",
  "cognitive.category_label": "Category: {cat}",
  "cognitive.delete_recommendation": "Delete recommendation",
  "cognitive.deselect_all": "Deselect all",
  "cognitive.game.decision": "1\" Decision",
  "cognitive.game.freno": "Brake",
  "cognitive.game.memoria": "Memory",
  "cognitive.game.ojo": "Tactical Eye",
  "cognitive.game.respiracion": "4-4 Breathing",
  "cognitive.game.semaforo": "Traffic Light",
  "cognitive.level_by_game_title": "Level per Game (Adaptive Merit)",
  "cognitive.metric_avg_accuracy": "Average accuracy",
  "cognitive.metric_median_reaction": "Median reaction",
  "cognitive.metric_sessions_week": "Sessions this week",
  "cognitive.metric_trend": "Trend",
  "cognitive.modal_assign_title": "⭐ Assign Challenges or Games",
  "cognitive.modal_cog_games": "🧠 Cognitive Games ({count}/{total}):",
  "cognitive.modal_confirm_assign": "Confirm {count} assignment(s)",
  "cognitive.modal_entire_team": "Entire team roster",
  "cognitive.modal_home_retos": "⚽ Home Challenges ({count}/{total}):",
  "cognitive.modal_only_player": "Only {name}",
  "cognitive.modal_recipient_label": "Recipient:",
  "cognitive.modal_select_min": "Select at least one challenge or game",
  "cognitive.recommendation_deleted": "Recommendation deleted",
  "cognitive.select_all": "Select all",
  "cognitive.supervision_title": "Cognitive Supervision & Home Challenges",
  "cognitive.target_player": "Individual",
  "cognitive.target_team": "Entire team",
  "cognitive.trend_improving": "↑ Improving",
  "cognitive.trend_stable": "= Stable",
  "cognitive.verified_xp": "✔ Challenges verified: +5 XP assigned to {name}",
  "cognitive.verify_error": "Error registering verification",
  "cognitive.week_sessions": "Current week · {count} recorded sessions",
  "common.absent": "Absent",
  "common.all": "ALL",
  "common.away": "Away",
  "common.back": "Back",
  "common.cancel": "Cancel",
  "common.close": "Close",
  "common.closeMenu": "Close menu",
  "common.delete": "Delete",
  "common.edit": "Edit",
  "common.email": "Email",
  "common.errorGeneral": "An unexpected error occurred",
  "common.excused": "Excused",
  "common.friendly": "Friendly",
  "common.genericError": "Operation error",
  "common.home": "Home",
  "common.injured": "Injured",
  "common.loading": "Loading...",
  "common.matchTag": "Match",
  "common.myTeam": "My Team",
  "common.no": "No",
  "common.noData": "No data",
  "common.official": "Official",
  "common.optimal": "Optimal",
  "common.originalBadgeEn": "EN original",
  "common.originalBadgeEs": "ES original",
  "common.originalLanguage": "Original language",
  "common.originalLanguageEn": "Original language: English",
  "common.originalLanguageEs": "Original language: Spanish",
  "common.player": "Player",
  "common.present": "Present",
  "common.risk": "Risk",
  "common.rival": "Opponent",
  "common.save": "Save",
  "common.savedSuccess": "Saved successfully",
  "common.saving": "Saving...",
  "common.sessionTag": "Session",
  "common.starter": "Starter",
  "common.substitute": "Substitute",
  "common.success": "Operation completed successfully",
  "common.training": "Training",
  "common.yes": "Yes",
  "consent.authAvatar": "Photo or identifying avatar of the player in line-ups and tactical board",
  "consent.authBiometric": "Anthropometric sheet (height and body weight for physical monitoring and BMI)",
  "consent.authDob": "Date of birth (Required for automatic age and category calculation)",
  "consent.authExercises": "Assignment of recovery and individual training plans",
  "consent.authInjuries": "Clinical history of suffered injuries (medical health data - GDPR Art. 9)",
  "consent.authName": "Full name (Required for player profile)",
  "consent.authPhysicalTests": "Fitness and performance physical test results",
  "consent.authPosition": "Sport position and assigned jersey number",
  "consent.authPsychosocial": "Psychosocial questionnaires and daily wellness tests (fatigue, sleep, stress, mood)",
  "consent.authSessions": "Attendance and participation records in matches, line-ups and technical reports",
  "consent.clearSig": "Clear signature pad",
  "consent.coachNameLabel": "Head Coach / Responsible",
  "consent.coachNamePlaceholder": "Coach Name",
  "consent.detailsTitle": "Consent Details",
  "consent.errBasicAuth": "It is mandatory to authorize the processing of name and date of birth to register the player in the app.",
  "consent.errParentDni": "Guardian ID/Passport is required.",
  "consent.errParentName": "Parent/guardian name is required.",
  "consent.errPlayerDob": "Player date of birth is required.",
  "consent.errPlayerName": "Player name (underage) is required.",
  "consent.errSig": "Please draw your digital signature in the box before proceeding.",
  "consent.footerLegal": "Mister11 does not store your contact data, signature, or PDF file in its databases. The PDF document is processed temporarily and instantly in the memory of your own mobile/computer browser. The legal custody of the signed PDF document rests entirely with the parents/guardians and the coach in charge of team management.",
  "consent.heading": "Digital Parental Consent",
  "consent.instructions": "Fill in the required information. Fields marked with (*) are mandatory.",
  "consent.notifyWhatsapp": "Notify Coach via WhatsApp",
  "consent.parentDniLabel": "ID / NIE / Passport *",
  "consent.parentDniPlaceholder": "e.g. 12345678Z",
  "consent.parentNameLabel": "Guardian Name *",
  "consent.parentNamePlaceholder": "Full Name",
  "consent.parentPhoneLabel": "Contact Phone",
  "consent.parentPhonePlaceholder": "e.g. +34 600 000 000",
  "consent.playerDobLabel": "Date of Birth *",
  "consent.playerNameLabel": "Player Name *",
  "consent.playerNamePlaceholder": "Full Name",
  "consent.privacyDesc": "This document has been generated locally. Mister11 does not store copies of your signature or consent on its servers. Send the downloaded PDF to the coach via WhatsApp to keep it safely.",
  "consent.privacyTitle": "PRIVACY NOTICE",
  "consent.redownloadPdf": "Download PDF Again",
  "consent.relationFather": "Father",
  "consent.relationGuardian": "Legal Guardian / Representative",
  "consent.relationLabel": "Relationship *",
  "consent.relationMother": "Mother",
  "consent.seasonLabel": "Season",
  "consent.sec1": "1. Parent or Legal Guardian Details",
  "consent.sec2": "2. Underage Player Details",
  "consent.sec3": "3. Team and Coach Details",
  "consent.sec4": "4. Personal Data Authorizations",
  "consent.sec4Desc": "Select what data you authorize to be processed in Mister11 by the coaching staff:",
  "consent.sec5": "5. Express Consent Declaration",
  "consent.sec5Text": "Hereby, acting as father, mother or legal guardian of the underage player indicated above, I declare that I have been transparently informed about the purpose and processing of the sports and wellness data of the player on the Mister11 platform. I grant my express consent to the processing of the boxes checked above.",
  "consent.sec6": "6. Digital Signature of Guardian",
  "consent.sigLabel": "Draw your Signature with Finger or Mouse *",
  "consent.subTitle": "Informed authorization for the sports management of the underage player.",
  "consent.submitBtn": "Sign and Generate PDF Document",
  "consent.submittingBtn": "Generating signed PDF...",
  "consent.successDesc": "The parental consent document for player {name} has been generated and downloaded to your device successfully.",
  "consent.successTitle": "Successfully Signed!",
  "consent.teamNameLabel": "Team / Club",
  "consent.teamNamePlaceholder": "Team Name",
  "consent.whatsappMsg": "Hello coach, I have already completed and digitally signed the parental consent for {name}. I downloaded the signed PDF to my device. I will share it with you next.",
  "convocation.allRecipientsSelected": "All selected",
  "convocation.cleanSelection": "Clear selection",
  "convocation.coachLabel": "COACH / ENTRENADOR",
  "convocation.competition": "Competition",
  "convocation.counter": "{count}/18 selected",
  "convocation.defaultMessage": "Call-up squad for the match vs {opponent}. Please check the details.",
  "convocation.download": "Download PNG",
  "convocation.downloading": "Downloading...",
  "convocation.generate": "Generate convocation PNG",
  "convocation.generatedWith": "Generated with Mister11",
  "convocation.generating": "Generating PNG...",
  "convocation.limitReached": "Limit reached: maximum 18 players selected",
  "convocation.matchInfo.convocationTime": "Call-up time (-1h)",
  "convocation.matchInfo.date": "Date",
  "convocation.matchInfo.location": "Location",
  "convocation.matchInfo.matchTime": "Match time",
  "convocation.matchInfo.rival": "Opponent",
  "convocation.message": "Announcement message",
  "convocation.missingPlayersWarning": "18 players are recommended for a full squad call-up.",
  "convocation.noMatchSelected": "No upcoming match scheduled.",
  "convocation.noPlayersSelected": "You have not selected any players.",
  "convocation.positions.def": "DEFENDERS",
  "convocation.positions.fwd": "FORWARDS",
  "convocation.positions.gk": "GOALKEEPERS",
  "convocation.positions.mid": "MIDFIELDERS",
  "convocation.positionsEn.def": "DEFENSAS",
  "convocation.positionsEn.fwd": "DELANTEROS",
  "convocation.positionsEn.gk": "PORTEROS",
  "convocation.positionsEn.mid": "MEDIOCAMPISTAS",
  "convocation.previewTitle": "Convocation Preview",
  "convocation.quickAccess": "Next match convocation",
  "convocation.regenerate": "Regenerate / Edit",
  "convocation.round": "Matchday",
  "convocation.selectPlayers": "Select called-up players",
  "convocation.send": "Send",
  "convocation.sendError": "Error sending convocation.",
  "convocation.sendModalTitle": "Send Convocation to Players",
  "convocation.sendSuccess": "Convocation sent to players successfully.",
  "convocation.sendToPlayers": "Send to players",
  "convocation.sending": "Sending...",
  "convocation.tab": "Squad List",
  "convocation.title": "Convocation",
  "csv.browseFile": "Browse File",
  "csv.confirmImport": "Confirm and Import Players",
  "csv.continueToPreview": "Continue to Preview",
  "csv.downloadTemplate": "Download CSV Template",
  "csv.dropzoneDesc": "Supported files: .csv, .xlsx, .xls (max 5MB)",
  "csv.dropzoneTitle": "Drag and drop your file here or click to browse",
  "csv.errorDuplicateNumberFile": "Duplicate shirt number within the file.",
  "csv.errorDuplicateNumberTeam": "Shirt number is already taken in this team.",
  "csv.errorEmptyFile": "The selected file is empty.",
  "csv.errorInvalidNumber": "Shirt number must be an integer between 1 and 99.",
  "csv.errorInvalidPosition": "Invalid position. Use GK, DEF, MID, FWD or equivalent.",
  "csv.errorMissingName": "Player name is required.",
  "csv.errorParsing": "Could not read file. Check CSV or Excel formatting.",
  "csv.errorPlanLimitExceeded": "You have reached the maximum players allowed by your plan.",
  "csv.errorUnsupportedFormat": "Unsupported format. Use .csv or .xlsx files.",
  "csv.fieldBirthDate": "Date of Birth",
  "csv.fieldDorsal": "Shirt / Jersey Number",
  "csv.fieldEmail": "Email Address",
  "csv.fieldOptional": "Optional",
  "csv.fieldPlayerName": "Player Name",
  "csv.fieldPosition": "Primary Position",
  "csv.fieldRequired": "Required",
  "csv.importErrorToast": "An error occurred while importing players.",
  "csv.importSuccessToast": "{count} players imported successfully.",
  "csv.mappingIntro": "Map columns from your spreadsheet to Mister11 fields:",
  "csv.modalTitle": "Import Players via CSV / Excel",
  "csv.selectColumn": "Select column...",
  "csv.status": "Status",
  "csv.stepMapping": "Mapping",
  "csv.stepPreview": "Preview",
  "csv.stepUpload": "Upload",
  "csv.summaryErrors": "Rows with errors to fix:",
  "csv.summaryReady": "Players ready for import:",
  "csv.tagValid": "Valid",
  "csv.templateSubtitle": "Download our official CSV template with predefined headers.",
  "csv.templateTitle": "Need a template?",
  "dashboard.activity": "Here is your team activity ({club}) for this week.",
  "dashboard.devAccess": "Developer Access - Mister11 PRO",
  "dashboard.devDesc": "Your account has lifetime access with all limits removed.",
  "dashboard.devUnlimited": "✔ UNLIMITED DEVELOPER",
  "dashboard.estimatedWorkload": "Estimated Workload",
  "dashboard.joinAsStaff": "Join as Staff",
  "dashboard.noUpcomingSessions": "No upcoming sessions.",
  "dashboard.period.macro": "This macrocycle",
  "dashboard.period.meso": "This mesocycle",
  "dashboard.period.micro": "This microcycle",
  "dashboard.period.session": "This session",
  "dashboard.period.week": "This week",
  "dashboard.quickAccess": "Quick Access",
  "dashboard.saveDashboard": "SAVE DASHBOARD",
  "dashboard.stats.matches": "Matches",
  "dashboard.stats.noRival": "No opponent",
  "dashboard.stats.players": "Players",
  "dashboard.stats.rival": "Next Opponent",
  "dashboard.stats.sessions": "Sessions",
  "dashboard.teamWorkloadIndex": "Team Workload Index",
  "dashboard.today": "Today",
  "dashboard.upcomingSessions": "Upcoming Sessions",
  "dashboard.upgrade.activatePro": "Activate PRO Mode",
  "dashboard.upgrade.activateProTrial": "Activate PRO Trial",
  "dashboard.upgrade.freePlanDesc": "Active limits: 1 team, 23 players, 10 sessions and 5 AI generations per month.",
  "dashboard.upgrade.freePlanTitle": "⭐ Mister11 Free Plan (Limited)",
  "dashboard.upgrade.planActiveDesc": "You have full access to all features. Thank you for being part of Mister11 PRO.",
  "dashboard.upgrade.planActiveTitle": "👑 Mister11 {plan} · Active Plan",
  "dashboard.upgrade.renewAccess": "🔓 RENEW ACCESS",
  "dashboard.upgrade.resetTrial": "Reset",
  "dashboard.upgrade.subscribe": "⚡ SUBSCRIBE",
  "dashboard.upgrade.trialActiveDesc": "You have full access to all premium features. You have {days} days ({hours}h) of trial remaining.",
  "dashboard.upgrade.trialActiveTitle": "👑 Mister11 {plan} · Free Trial Active",
  "dashboard.upgrade.trialExpiredDesc": "🔒 Your free trial has ended. Subscribe to restore PRO access.",
  "dashboard.upgrade.trialExpiringDesc": "Only {hours} left of your trial. Subscribe to maintain access.",
  "dashboard.upgrade.trialExpiringTitle": "⚠️ Your trial expires soon!",
  "dashboard.upgrade.tryFree": "Try Free Plan",
  "dashboard.upgrade.viewPlans": "View PRO Plans",
  "dashboard.upgrade.viewPlansPro": "👑 VIEW PRO PLANS",
  "dashboard.viewAll": "View all",
  "dashboard.weeklyReport.desc": "Summary of trainings and matches this week ({sessions} sessions, {matches} matches).",
  "dashboard.weeklyReport.download": "Download PDF",
  "dashboard.weeklyReport.ready": "Your Weekly Report is ready!",
  "dashboard.welcome": "Hello, {name}",
  "dashboard.workload.week": "Wk",
  "day.Dom": "Sun",
  "day.Jue": "Thu",
  "day.Lun": "Mon",
  "day.Mar": "Tue",
  "day.Mié": "Wed",
  "day.Sáb": "Sat",
  "day.Vie": "Fri",
  "download.cache_hint": "Saved to cache. If it does not open, look for \"{filename}\" in Files",
  "download.csv_success": "✅ Template exported successfully.",
  "download.generic_error": "Error exporting lineup",
  "download.image_success": "✅ Image exported successfully.",
  "download.json_success": "✅ File exported successfully.",
  "download.lineup_downloading": "⬇️ Downloading lineup: {filename}",
  "download.lineup_saved": "✅ Lineup saved to {path}",
  "download.lineup_share_dialog": "Save or share lineup...",
  "download.lineup_share_title": "Mister11 — Lineup {team}",
  "download.pdf_error": "Error saving PDF",
  "download.pdf_ready": "✅ PDF ready: \"{filename}\"",
  "download.save_error_share_fallback": "⚠️ Could not save file automatically; please use Share.",
  "download.saved_in": "✅ Saved in: {path}",
  "download.video_success": "✅ Animation exported successfully.",
  "equipo.loadingSquad": "Loading squad...",
  "equipo.publishAnnouncement": "Publish Announcement",
  "equipo.tab.attendance": "Attendance Tracking",
  "equipo.tab.squad": "Squad",
  "equipo.tab.staff": "Technical Staff",
  "equipo.title": "Team Management",
  "error.retry_section": "Retry",
  "error.section_code": "Code: {code}",
  "error.section_desc": "An isolated anomaly occurred while rendering this section. The rest of the match remains operational.",
  "error.section_unavailable": "Section temporarily unavailable",
  "errors.codeAlreadyUsed": "This code has already been used.",
  "errors.codeExpired": "This invitation has expired.",
  "errors.codeInvalid": "Invalid code. Must have 6 characters.",
  "errors.codeNotFound": "Team not found. Verify the code or contact the coach.",
  "exerciseCatalog.categories.cooldown": "Cool-Down",
  "exerciseCatalog.categories.main": "Main Part",
  "exerciseCatalog.categories.warmup": "Warm-Up",
  "exerciseCatalog.clinicalFallbackNotice": "Official source under verification",
  "exerciseCatalog.phases.fase1": "Phase 1: Running & Dynamic Warm-Up",
  "exerciseCatalog.phases.fase2": "Phase 2: Strength, Plyometrics & Balance",
  "exerciseCatalog.phases.fase3": "Phase 3: High-Speed Running & Cutting Movements",
  "exerciseCatalog.sourceLabel": "Source",
  "exports.gk.claims": "Claims / Punches",
  "exports.gk.cleanSheets": "Clean Sheets",
  "exports.gk.conceded": "Goals Conceded",
  "exports.gk.errors": "Errors",
  "exports.gk.goalkeeper": "Goalkeeper",
  "exports.gk.penaltySaves": "Penalties Saved",
  "exports.gk.rating": "GK Rating",
  "exports.gk.savePct": "% Save Efficiency",
  "exports.gk.saves": "Saves",
  "exports.gk.title": "GOALKEEPING PERFORMANCE",
  "exports.report.match_info": "Match Sheet",
  "exports.report.page": "Page",
  "exports.report.sec10_players": "10. Individual Player Stats & Squad Performance",
  "exports.report.sec11_swot": "11. Tactical SWOT Analysis & Recommendations",
  "exports.report.sec1_lineup": "1. Tactical Lineup with Photos",
  "exports.report.sec2_timeline": "2. Scoreboard & Event Timeline",
  "exports.report.sec3_momentum": "3. Momentum & 15-Minute Possession Blocks",
  "exports.report.sec4_bars": "4. Comparative Bars (10 Metrics)",
  "exports.report.sec5_radar": "5. Comparative Radar (Own vs Opponent)",
  "exports.report.sec6_top5": "6. Top-5 Differential Metrics",
  "exports.report.sec7_shots": "7. Shot Maps & xG-Lite Model",
  "exports.report.sec8_tactics": "8. Pitch & Tactics (Corridors, Set Pieces & Territory)",
  "exports.report.sec9_gk": "9. Goalkeeping Exertion & Performance",
  "exports.report.sec_photos": "Match Photos & Evidence",
  "exports.report.tactical_analysis": "Tactical Analysis",
  "exports.report.title": "OFFICIAL POST-MATCH REPORT",
  "exports.test.attendance": "Attendance",
  "exports.test.mental": "Mental / Psychosocial Test",
  "exports.test.physical": "Physical Test",
  "exports.test.radar_title": "Comprehensive Performance Profile",
  "exports.test.recommendation_title": "Individual Recommendations",
  "exports.test.table_interp": "Interpretation",
  "exports.test.table_score": "Score",
  "exports.test.table_test": "Test",
  "exports.test.tactical": "Tactical Test",
  "exports.test.technical": "Technical Test",
  "exports.test.title": "EVALUATION & TESTS REPORT",
  "form.teamName": "Team Name",
  "games.assignment.todayPrompt": "Coaching staff has assigned you a special challenge",
  "games.badge.recommended": "Recommended by your coach",
  "games.best.accuracy": "Accuracy: {val}%",
  "games.best.hits": "Hits: {val}/5",
  "games.best.maxCones": "Max: {val} cones",
  "games.best.record": "Record: {val} ms",
  "games.btn.backToCatalog": "Back to Catalog",
  "games.btn.play": "Play",
  "games.btn.practiceFirst": "Try in Practice Mode",
  "games.btn.startOfficial": "Start Session",
  "games.btn.startReto": "Train",
  "games.disclaimer": "Support cognitive training, not therapy; follow specialist advice for ADHD.",
  "games.finish.healthyClosing": "Great mental work! Rest your eyes and body.",
  "games.finish.subtitle": "You have completed the session with dedication.",
  "games.finish.title": "Outstanding effort!",
  "games.g1.falseStart": "🚫 False start.",
  "games.g1.skill": "Reaction Speed",
  "games.g1.statBest": "Best record",
  "games.g1.statFalses": "False starts",
  "games.g1.statMedian": "Median",
  "games.g1.step1": "Wait on red.",
  "games.g1.step2": "Tap the screen when it turns GREEN.",
  "games.g1.step3": "Tapping earlier = false start.",
  "games.g1.tapAreaPrompt": "Tap here when it turns GREEN",
  "games.g1.tapNow": "TAP NOW!",
  "games.g1.title": "Pro Traffic Light",
  "games.g1.tooSlow": "Too slow! Miss.",
  "games.g1.waitGreen": "Wait for green…",
  "games.g1.what": "React in milliseconds: reach the ball before your opponent.",
  "games.g1.why": "Arriving 0.2s earlier to a loose ball changes the play. Reaction can be trained and transfers to runs and interceptions.",
  "games.g2.crMsg": "🛑 Perfect brake!",
  "games.g2.faMsg": "🚫 It was red: you had to brake.",
  "games.g2.missMsg": "⏱️ Green slipped away.",
  "games.g2.prepare": "Watch the cone…",
  "games.g2.skill": "Self-control & Decision",
  "games.g2.statAcc": "Accuracy",
  "games.g2.statFa": "Failed brakes",
  "games.g2.statRt": "Average time",
  "games.g2.step1": "A cone appears in one of the squares.",
  "games.g2.step2": "GREEN → tap it quickly.",
  "games.g2.step3": "RED → do NOT tap, brake your finger.",
  "games.g2.title": "Impulse Brake",
  "games.g2.what": "Hold back impulses: decide before taking action.",
  "games.g2.why": "Most mistakes come from acting hastily. The \"brake\" improves dribbling, prevents fouls and helps players with ADHD.",
  "games.g3.hitMsg": "✅ Open teammate found!",
  "games.g3.markedMsg": "❌ That one was marked. Look for the open one.",
  "games.g3.practiceGuide": "The open teammate shines in gold. Tap them!",
  "games.g3.rivalMsg": "😉 That is an opponent. Look for your teammate.",
  "games.g3.scanPrompt": "Scan with your eyes…",
  "games.g3.skill": "Visual Scanning & Perception",
  "games.g3.statHits": "Hits",
  "games.g3.statRounds": "Rounds",
  "games.g3.statTime": "Average time",
  "games.g3.step1": "🟢 teammates · 🔴 opponents.",
  "games.g3.step2": "Tap the teammate with the MOST open space.",
  "games.g3.step3": "5 seconds per round.",
  "games.g3.timeOut": "⏱️ Time up. The open player was the clearest.",
  "games.g3.title": "Tactical Eye",
  "games.g3.what": "See the pitch: find the open teammate before receiving.",
  "games.g3.why": "Pros scan 6-8 times every 10 s. Spotting the open player before receiving turns a good decision into a great pass.",
  "games.g4.correctMsg": "✅ Perfect sequence!",
  "games.g4.missMsg": "❌ Close. Keep trying.",
  "games.g4.repeat": "Repeat the sequence!",
  "games.g4.skill": "Working Memory",
  "games.g4.statMax": "Max sequence",
  "games.g4.statOk": "Rounds cleared",
  "games.g4.statRange": "Range",
  "games.g4.step1": "Watch the order in which the cones light up.",
  "games.g4.step2": "Repeat the sequence by tapping the same cones.",
  "games.g4.step3": "Each round the sequence gets longer.",
  "games.g4.title": "Cone Memory",
  "games.g4.watch": "Watch closely…",
  "games.g4.what": "Remember information under pressure.",
  "games.g4.why": "Remembering cues and patterns sharpens attention and tactical comprehension: the player's \"mental board\".",
  "games.g5.cycleHeader": "Cycle {current} of {total}",
  "games.g5.exhale": "Exhale",
  "games.g5.exhaleTip": "Release the breath gently through your mouth",
  "games.g5.inhale": "Inhale",
  "games.g5.inhaleTip": "Inhale slowly through your nose filling your abdomen",
  "games.g5.skill": "Calm & Self-Control",
  "games.g5.statBenefit": "Benefit",
  "games.g5.statCycles": "Cycles",
  "games.g5.statTempo": "Tempo",
  "games.g5.step1": "Circle expands → inhale gently through your nose (4 s).",
  "games.g5.step2": "Circle shrinks → exhale slowly through your mouth (4 s).",
  "games.g5.step3": "6 complete cycles, no rush or scoring.",
  "games.g5.title": "4-4 Breathing",
  "games.g5.what": "Calm nerves before playing.",
  "games.g5.why": "4-4 box breathing activates the parasympathetic system: lowers heart rate and anxiety in ~1 min. Used by elite athletes; it's simple and done anywhere. That's why we chose it.",
  "games.g5.zenBadge": "6 calm cycles",
  "games.g6.clueGoal": "Goal:",
  "games.g6.clueMate": "Teammate:",
  "games.g6.clueSpace": "Open space:",
  "games.g6.optDribble": "DRIBBLE",
  "games.g6.optPass": "PASS",
  "games.g6.optShoot": "SHOT",
  "games.g6.prompt": "Decide fast!",
  "games.g6.skill": "Tactical Reading",
  "games.g6.statAcc": "Hits",
  "games.g6.statPct": "Accuracy",
  "games.g6.statTime": "Average time",
  "games.g6.step1": "Read the 3 clues on screen.",
  "games.g6.step2": "Goal OPEN → SHOT.",
  "games.g6.step3": "Otherwise, teammate OPEN → PASS. Else → DRIBBLE (4 s limit).",
  "games.g6.timeOutMsg": "⏱️ Time up. The best choice was {option}.",
  "games.g6.title": "1-Second Decision",
  "games.g6.what": "Pick the best action at a glance: pass, shot or dribble.",
  "games.g6.why": "Football is played with the head: deciding fast and well sets great players apart.",
  "games.honesty.pact": "Honesty pact: record your real repetitions. The effort is yours!",
  "games.intro.howTitle": "How to Play",
  "games.intro.whatTitle": "What We Train",
  "games.intro.whyTitle": "Why It Helps on the Pitch",
  "games.legend_ceiling": "👑 You reached the Legend ceiling! You are a legend!",
  "games.level_up": "🎉 You leveled up to {level}! {badge} (+10 XP)",
  "games.limits.available": "Available",
  "games.limits.cognitiveLbl": "Cognitive Games",
  "games.limits.cognitiveLockedDesc": "You have reached the healthy limit of 15 minutes of cognitive games. Rest your mind to consolidate what you learned!",
  "games.limits.cognitiveLockedTitle": "🧠 Mind trained for today!",
  "games.limits.completed": "Completed",
  "games.limits.completedToday": "Completed for today",
  "games.limits.lockedDesc": "You have reached the healthy daily training limit. Come back tomorrow to keep improving.",
  "games.limits.lockedTitle": "Well done for today!",
  "games.limits.minutesLbl": "Time played",
  "games.limits.remainingMin": "{count} min remaining today",
  "games.limits.remainingTime": "{time} remaining today",
  "games.limits.retosLbl": "Home Challenges",
  "games.limits.retosLockedDesc": "You have reached your 20 minutes of home challenges for today. Great physical effort, recover for the next practice!",
  "games.limits.retosLockedTitle": "⚽ Body and technique trained!",
  "games.limits.sessionsLbl": "Sessions today",
  "games.limits.title": "Healthy Training",
  "games.ranking.empty": "Start your training to open the week's podium.",
  "games.ranking.resetInfo": "Resets every Monday",
  "games.ranking.subtitle": "A healthy growth space rewarding consistency and personal improvement, not cut-throat rivalry.",
  "games.ranking.tabImproved": "Most Improved",
  "games.ranking.tabPoints": "Weekly Points",
  "games.ranking.title": "Healthy Weekly Ranking",
  "games.retos.addRep": "+1 Repetition",
  "games.retos.attemptsExhausted": "Limit of 2 attempts reached for today. Rest and come back tomorrow!",
  "games.retos.attemptsToday": "attempts today",
  "games.retos.btnStart": "Start Challenge",
  "games.retos.btnSuperado": "Completed today",
  "games.retos.completedBadge": "Completed today",
  "games.retos.completedResult": "Completed",
  "games.retos.crp.metric": "Best streak",
  "games.retos.crp.skill": "Body control",
  "games.retos.crp.title": "Head-Knee-Foot",
  "games.retos.crp.what": "Head-knee-foot control sequence.",
  "games.retos.cuerda.metric": "Total jumps",
  "games.retos.cuerda.skill": "Footwork agility and stamina",
  "games.retos.cuerda.title": "Jump Rope",
  "games.retos.cuerda.what": "Foot speed agility and stamina.",
  "games.retos.dom.metric": "Best streak",
  "games.retos.dom.skill": "Touch and control",
  "games.retos.dom.title": "Ball Juggling",
  "games.retos.dom.what": "Ball touch and control.",
  "games.retos.eq.metric": "Sets completed",
  "games.retos.eq.skill": "Proprioception",
  "games.retos.eq.title": "Balance Challenge",
  "games.retos.eq.what": "Ankle balance and stability.",
  "games.retos.esc.metric": "Sets completed",
  "games.retos.esc.skill": "Foot quickness",
  "games.retos.esc.title": "Agility Ladder",
  "games.retos.esc.what": "Quick footwork and motor speed.",
  "games.retos.finishSet": "Finish Set ✔",
  "games.retos.lockedBtn": "Locked for today",
  "games.retos.pared.metric": "Total passes",
  "games.retos.pared.skill": "Passing and weak foot",
  "games.retos.pared.title": "Wall Passes",
  "games.retos.pared.what": "Accurate passing and non-dominant foot.",
  "games.retos.punt.metric": "Total hits",
  "games.retos.punt.skill": "Passing accuracy",
  "games.retos.punt.title": "Cone Target",
  "games.retos.punt.what": "Long-distance passing accuracy.",
  "games.retos.questionTimer": "Did you keep up the exercise for the whole duration?",
  "games.retos.recommendedBadge": "Assigned",
  "games.retos.reg.metric": "Sets completed",
  "games.retos.reg.skill": "Ball handling",
  "games.retos.reg.title": "Dribbling Slalom",
  "games.retos.reg.what": "Dribbling through cones with pace change.",
  "games.retos.repetitions": "{count} repetitions",
  "games.retos.setHeader": "Set {current} of {total}",
  "games.retos.setsWord": "sets",
  "games.retos.startTimer": "Start Timer",
  "games.retos.statSets": "Sets",
  "games.retos.statStatus": "Result",
  "games.retos.streakEnd": "Ball dropped / End of streak",
  "games.retos.timeExhausted": "You have reached the 20-minute daily challenge limit. Great physical effort!",
  "games.retos.touchesStreak": "{count} touches in a row",
  "games.safety.title": "Safety at Home",
  "games.status.notPlayed": "No record",
  "games.status.practice": "Practice (unscored)",
  "games.tabs.cognitive": "Cognitive Games (6)",
  "games.tabs.retos": "Home Challenges (8)",
  "games.timer.paused": "Paused",
  "games.timer.remainingChip": "Remaining today: {time}",
  "games.timer.setFinishing": "Final set",
  "gk.activeGoalkeeper": "GOALKEEPER ON PITCH",
  "gk.aerialClaim": "Saídas Aéreas",
  "gk.boxDominance": "Domínio de Área",
  "gk.btn.claim": "Claim / Punch",
  "gk.btn.conceded": "Conceded Goal",
  "gk.btn.errorGoal": "Error Leading to Goal",
  "gk.btn.penaltySave": "Penalty Saved",
  "gk.btn.save": "Save",
  "gk.buildup": "Saída de Bola / Construção",
  "gk.claims": "Claims & Punches",
  "gk.claimsShort": "Claims",
  "gk.cleanSheets": "Clean Sheets",
  "gk.cleanSheetsShort": "Clean Sh.",
  "gk.conceded": "Goals Conceded",
  "gk.concededShort": "Conc.",
  "gk.diveLow": "Queda Rasteira",
  "gk.errorGoal": "Errors Leading to Goal",
  "gk.errorGoalShort": "Err. Goal",
  "gk.events.empty": "No goalkeeping events recorded for this match.",
  "gk.events.list": "Goalkeeping Events",
  "gk.evolution": "Save % Evolution",
  "gk.history": "Match History",
  "gk.noActiveGoalkeeper": "No active goalkeeper on pitch",
  "gk.parrySafe": "Espalmada Segura",
  "gk.penaltySaves": "Penalties Saved",
  "gk.penaltySavesShort": "Pen. Saved",
  "gk.perMatch": "Per match",
  "gk.rating": "GK Rating",
  "gk.reflexClose": "Reflexos à Queima-Roupa",
  "gk.role": "Goalkeeper",
  "gk.roleBadge": "🧤 Goalkeeper",
  "gk.saveHigh": "Defesa no Alto",
  "gk.savePercentage": "Save %",
  "gk.savePercentageShort": "Save %",
  "gk.saves": "Saves",
  "gk.savesShort": "Saves",
  "gk.smother": "Dividida no Chão",
  "gk.suggest.confirm": "Yes, assign to goalkeeper",
  "gk.suggest.ignore": "No, record goal only",
  "gk.suggest.message": "An opponent goal was recorded. Do you want to add 1 conceded goal to the active goalkeeper ({name})?",
  "gk.suggest.title": "Assign conceded goal?",
  "gk.sweeper": "Goleiro Líbero",
  "gk.title": "Goalkeeper Metrics",
  "gk.tooltip.claim": "Aerial claim, interception, or punched clearance.",
  "gk.tooltip.cleanSheet": "Match completed with minutes played without conceding a goal.",
  "gk.tooltip.conceded": "Goal allowed while playing in goal.",
  "gk.tooltip.errorGoal": "Direct mistake in possession or positioning resulting in an opponent goal.",
  "gk.tooltip.penaltySave": "Penalty kick saved during the match.",
  "gk.tooltip.save": "Successful intervention preventing an opponent goal.",
  "header.logoutConfirm": "Do you want to log out or switch accounts?",
  "header.switchPlayerPortal": "Switch to Player Portal",
  "health.active": "Active",
  "health.addInjury": "+ Record Injury",
  "health.additionalNotes": "Additional Notes",
  "health.affectedArea": "Affected Area *",
  "health.cancel": "Cancel",
  "health.injuryDate": "Injury Date *",
  "health.injuryType": "Injury Type *",
  "health.markRecovered": "Mark as Recovered",
  "health.medicalNotes": "Medical Observations",
  "health.medicalNotesPlaceholder": "Allergies, ongoing treatments, medical notes...",
  "health.noInjuries": "No injuries recorded.",
  "health.recordInjury": "Record New Injury",
  "health.resolved": "Recovered",
  "health.saveInjury": "Save Injury",
  "health.status.active": "Available / Active",
  "health.status.current": "Current Status",
  "health.status.injured": "Injured",
  "health.status.recovery": "Recovering",
  "health.status.rest": "Rest",
  "health.title": "Medical History & Injuries",
  "health.updateStatus": "Update General Status",
  "ia.additionalObs": "Additional observations",
  "ia.age.alevin": "Under-12 (10-12)",
  "ia.age.amateur": "Senior / Amateur",
  "ia.age.base": "Grassroots (6-10 years)",
  "ia.age.cadete": "Under-16 (14-16)",
  "ia.age.infantil": "Under-14 (12-14)",
  "ia.age.juvenil": "Under-19 (16-18)",
  "ia.age.prebenjamin": "Under-10 (8-10)",
  "ia.animation": "Animation ({count}F)",
  "ia.btnClear": "🔄 Clear",
  "ia.btnExportPdf": "📄 Export PDF",
  "ia.btnGeneratePrevention": "🩺 Generate Exercise Plan",
  "ia.btnGenerateTactical": "✨ Generate Exercise",
  "ia.btnSave": "💾 Save",
  "ia.capture": "Capture",
  "ia.categoryAge": "CATEGORY / AGE",
  "ia.defaultTitle": "AI Exercise {time}",
  "ia.dictationNotSupported": "Your browser does not support voice dictation. Use Chrome on Android for this feature.",
  "ia.dictationStart": "Voice dictation",
  "ia.dictationStop": "Stop dictation",
  "ia.drawerTitle": "☁️ Cloud Library",
  "ia.durationMinutes": "{count} min",
  "ia.emptyLibrary": "No saved exercises yet.",
  "ia.emptyPlaceholder": "Your exercise will appear here",
  "ia.emptyResponse": "Empty response from AI",
  "ia.intensityLabel": "Intensidade",
  "ia.level.advanced": "Advanced",
  "ia.level.basic": "Basic",
  "ia.level.intermediate": "Intermediate",
  "ia.libraryBtn": "☁️ Library ({count})",
  "ia.limitReached": "You have reached the monthly limit of {limit} AI generations. The limit resets next month.",
  "ia.listening": "🔴 Listening... speak now",
  "ia.loadingAnalyzing": "⏳ Analyzing context...",
  "ia.loadingGenerating": "Generating...",
  "ia.loadingUsage": "🔑 AI: Loading usage...",
  "ia.mainObjective": "MAIN OBJECTIVE",
  "ia.mat.balls": "Footballs",
  "ia.mat.bibs": "Bibs",
  "ia.mat.cones": "Cones",
  "ia.mat.goals": "Goals",
  "ia.mat.hurdles": "Hurdles",
  "ia.mat.ladder": "Agility ladder",
  "ia.mat.none": "No specific equipment",
  "ia.mat.rings": "Rings",
  "ia.materials": "EQUIPMENT",
  "ia.modalDetail": "Details",
  "ia.modalLoad": "Load",
  "ia.modalNoContent": "No content.",
  "ia.modalOpenBoard": "Open in Board",
  "ia.modePrevention": "Prevention /\nRecovery",
  "ia.modeTactical": "Tactical\nDrill",
  "ia.noRef": "No Ref.",
  "ia.numPlayers": "NO. OF PLAYERS: {count}",
  "ia.obj.aerobic": "Aerobic endurance",
  "ia.obj.agility": "Agility & coordination",
  "ia.obj.cooldown": "Cool-down",
  "ia.obj.crossing": "Crossing & box arrivals",
  "ia.obj.finishing": "Finishing & shooting",
  "ia.obj.positional": "Positional play",
  "ia.obj.possession": "Ball possession",
  "ia.obj.pressing": "Pressing & counter-press",
  "ia.obj.speed": "Speed",
  "ia.obj.strength": "Strength & power",
  "ia.obj.transAttDef": "Transition attack-to-defense",
  "ia.obj.transDefAtt": "Transition defense-to-attack",
  "ia.obj.warmup": "Warm-up",
  "ia.obsPlaceholder": "E.g. Focus on execution speed or defensive transition...",
  "ia.phaseLabel": "Fase de jogo",
  "ia.prev.availableMaterial": "Available Equipment",
  "ia.prev.bodyZone": "Body Zone",
  "ia.prev.descLabel": "Clinical Description / Problem",
  "ia.prev.descPlaceholder": "E.g.: 16yo player with left hamstring overload post-match, requires eccentric and strengthening exercises...",
  "ia.prev.noMaterial": "No equipment",
  "ia.prev.planType": "Plan Type",
  "ia.prev.playerLevel": "Player Level",
  "ia.prev.typePrevention": "Prevention",
  "ia.prev.typeReadaptation": "Readaptation",
  "ia.prev.typeRecovery": "Recovery",
  "ia.recoveryNotice": "Sessão focada em regeneração muscular e prevenção.",
  "ia.saveError": "Error saving exercise. Please try again.",
  "ia.saveSuccess": "✅ Saved to library: \"{title}\"",
  "ia.selectPlaceholder": "Select...",
  "ia.space": "Pitch Area",
  "ia.space.box": "Penalty area",
  "ia.space.full": "Full pitch",
  "ia.space.gym": "Indoor / Gym",
  "ia.space.half": "Half pitch",
  "ia.space.small": "Small-sided area",
  "ia.space.threeQuarter": "3/4 pitch",
  "ia.subtitle": "SMART TRAINING SESSION DESIGN",
  "ia.tacticalBoard": "🎬 Board",
  "ia.tacticalRef": "Tactical Reference (Optional)",
  "ia.title": "AI Tactical Assistant",
  "ia.usageRemaining": "🔑 AI: you have {count} uses left this month (limit {limit})",
  "ia.validationPrevention": "Please describe the case and select a body zone.",
  "ia.validationTactical": "Please fill in: Age, Objective, and Pitch Area.",
  "ia.zone.adductors": "Adductors",
  "ia.zone.ankle": "Ankle",
  "ia.zone.calves": "Calves",
  "ia.zone.core": "Core / Pelvis",
  "ia.zone.hamstring": "Hamstring",
  "ia.zone.knee": "Knee",
  "ia.zone.lumbar": "Lower back",
  "ia.zone.quadriceps": "Quadriceps",
  "ia.zone.shoulder": "Shoulder",
  "install.alreadyInstalled": "The App is already installed on your device!",
  "install.androidDesc": "Tap the \"Install now\" button below or open the three dots menu (⋮) and select \"Install app\".",
  "install.androidTitle": "Android (Chrome):",
  "install.btnInstall": "Install now",
  "install.fallbackNotice": "If you do not see the install button, use the \"Add to Home Screen\" option in your browser.",
  "install.instructions": "Instructions:",
  "install.iosDesc": "Tap the \"Share\" button (square with arrow) and select \"Add to Home Screen\".",
  "install.iosTitle": "iOS (Safari):",
  "install.metaDesc": "Step-by-step installation instructions for Mister11 PWA on Android and iOS devices.",
  "install.metaTitle": "Install Mister11 — The Football App for Coaches",
  "install.slogan": "The bench in your pocket",
  "install.title": "Install Mister11",
  "invite.already_registered": "This email is already registered or invited to the club.",
  "invite.coach.codePlaceholder": "Invitation code (6 characters)",
  "invite.coach.scanQR": "Scan invitation QR",
  "invite.coach.title": "Join as Coach / Staff",
  "invite.generated_error": "Error generating the invitation.",
  "invite.generated_success": "Invitation generated successfully.",
  "invite.link_copied": "Link copied!",
  "invite.player.codePlaceholder": "Team code",
  "invite.player.scanQR": "Scan team QR",
  "invite.player.title": "Join Your Team",
  "joinTeam.account_created": "Account created successfully",
  "joinTeam.already_member": "You are already on this team! Loading your portal...",
  "joinTeam.google_sign_in": "Signed in with Google",
  "joinTeam.request_approved": "Your request has been approved!",
  "joinTeam.request_sent": "Request sent to the coach!",
  "joinTeam.welcome": "Welcome to Mister11",
  "live.action.foul": "Falta",
  "live.action.goal": "Gol",
  "live.action.offside": "Impedimento",
  "live.action.recovery": "Recuperação",
  "live.action.redCard": "Cartão Vermelho",
  "live.action.shot": "Finalização",
  "live.action.turnover": "Perda de bola",
  "live.action.yellowCard": "Cartão Amarelo",
  "live.btn.card_red_own": "Red Card (Own)",
  "live.btn.card_red_rival": "Red Card (Opponent)",
  "live.btn.card_yellow_own": "Yellow Card (Own)",
  "live.btn.card_yellow_rival": "Yellow Card (Opponent)",
  "live.btn.corner_against": "Corner Against",
  "live.btn.corner_favor": "Corner in Favor",
  "live.btn.counter_not_cut": "Uncut Counter",
  "live.btn.duel_lost": "Duel Lost",
  "live.btn.duel_won": "Duel Won",
  "live.btn.foul_against": "Foul Against",
  "live.btn.foul_favor": "Foul in Favor",
  "live.btn.loss": "Ball Loss",
  "live.btn.offside_own": "Offside (Own)",
  "live.btn.offside_rival": "Offside (Opponent)",
  "live.btn.player_no_finish": "Unfinished Play",
  "live.btn.recovery": "Ball Recovery",
  "live.btn.save_own": "Goalkeeper Save (Own)",
  "live.btn.save_rival": "Goalkeeper Save (Opponent)",
  "live.btn.shot_off_own": "Shot off Target (Own)",
  "live.btn.shot_off_rival": "Shot off Target (Opponent)",
  "live.btn.shot_on_own": "Shot on Target (Own)",
  "live.btn.shot_on_rival": "Shot on Target (Opponent)",
  "live.tab.analytics": "Advanced Analysis",
  "live.tab.capture": "Live Capture",
  "live.tab.players": "Players & CSV",
  "live.tab.tactical": "Field & Tactics",
  "liveStats.quickMode.advanced": "Advanced options",
  "liveStats.quickMode.shotSaved": "Shot recorded",
  "liveStats.quickMode.simple": "Simple mode",
  "liveStats.quickMode.title": "Quick Mode",
  "liveStats.quickMode.undo": "Undo",
  "liveStats.quickMode.undone": "Shot undone",
  "livestats.match_locked_short": "⚠️ Match completed",
  "livestats.match_locked_use_reopen": "⚠️ Match completed — use Reopen Match Sheet to correct.",
  "livestats.post_match_saved": "✅ Post-match counters saved",
  "livestats.select_player_first": "👆 Select a player first",
  "login.account_created": "Account created successfully!",
  "login.cancelled": "Sign-in cancelled by user",
  "login.recovery_error": "Error sending email",
  "login.recovery_sent": "Recovery link sent to your email",
  "login.welcome": "Welcome to Mister11!",
  "login.write_email_first": "Please enter your email first",
  "match.btn.exportIcs": "EXPORT ICS",
  "match.btn.newMatch": "+ NEW MATCH",
  "match.btn.pdfCalendar": "PDF CALENDAR",
  "match.defaultMyTeam": "My Team",
  "match.defaultRival": "Opponent",
  "match.filter.all": "All",
  "match.filter.finished": "Finished",
  "match.filter.pending": "Pending",
  "match.formationLabel": "Formation: ",
  "match.locked_reopen": "⚠️ Match completed. Reopen match sheet to record events.",
  "match.management.title": "MATCH MANAGEMENT",
  "match.noVenue": "No venue",
  "match.sort.cercania": "Closest to today",
  "match.sort.estado": "By Status / Priority",
  "match.sort.fecha_asc": "Date (Upcoming)",
  "match.sort.fecha_desc": "Date (Recent)",
  "match.sort.label": "Sort by",
  "match.sort.lejania": "Farthest from today",
  "match.status.en_edicion": "IN EDITION",
  "match.status.finalizado": "FINISHED",
  "match.status.no_disputado": "NOT PLAYED",
  "match.status.pendiente": "PENDING",
  "match.venue.local": "Home Venue",
  "match.venue.municipal": "Municipal Stadium",
  "match.view.cards": "Cards",
  "match.view.detailed": "Detailed",
  "matchSheet.anomalies_resolved": "✔ {count} anomaly(ies) resolved and sheet synchronized.",
  "matchSheet.auto_badge": "Auto",
  "matchSheet.close_error": "❌ Error closing match sheet. Please try again.",
  "matchSheet.closed_success": "✅ Match sheet closed. Real minutes saved.",
  "matchSheet.closed_with_warnings": "⚠️ Match sheet closed with recorded warnings.",
  "matchSheet.confirm_save_btn": "💾 CONFIRM & SAVE SHEET",
  "matchSheet.confirm_save_tooltip": "Save all manual minute corrections and update the official match sheet",
  "matchSheet.log_already_clean": "✨ The match log is already clean. Zero impossible events.",
  "matchSheet.log_debug_error": "❌ Error debugging log.",
  "matchSheet.manual_allowed_closed": "allowed even when closed",
  "matchSheet.manual_badge": "Manual",
  "matchSheet.manual_override_title": "Manual minutes override",
  "matchSheet.prefill_rsvp_empty": "No pending RSVP responses to pre-fill.",
  "matchSheet.prefill_rsvp_error": "❌ Error pre-filling from RSVP.",
  "matchSheet.prefill_rsvp_success": "✅ Statuses pre-filled from RSVP.",
  "matchSheet.prefill_smart_error": "❌ Error in smart pre-filling.",
  "matchSheet.prefill_smart_success": "⚡ Match sheet smartly pre-filled from lineup and events.",
  "matchSheet.referee": "Árbitro",
  "matchSheet.reopen_error": "❌ Error reopening match sheet.",
  "matchSheet.reopened_info": "🔓 Match sheet and match reopened for corrections.",
  "matchSheet.saving": "💾 Saving...",
  "matchSheet.signatures": "Assinaturas Oficiais",
  "matchSheet.tactical_grade_saved": "⭐ Tactical rating saved",
  "matchSheet.weather": "Clima / Gramado",
  "matches.finish_error": "❌ Error saving completion:",
  "matches.lineup.benchTitle": "SUBSTITUTES BENCH",
  "matches.lineup.downloadPng": "DOWNLOAD PNG",
  "matches.lineup.emptySlot": "Empty",
  "matches.lineup.exportingPng": "EXPORTING...",
  "matches.lineup.subtitle": "Tactical board with starting XI and substitutes bench",
  "matches.lineup.title": "Tactical Lineup & Bench",
  "matches.log_cleanse_error": "❌ Error cleansing log.",
  "matches.log_cleansed": "🧹 Log cleansed successfully. {count} records sanitized.",
  "matches.repair_error": "❌ Error repairing match.",
  "matches.repaired": "✅ Match repaired and persisted successfully.",
  "matches.warnings.auditHide": "Hide audit",
  "matches.warnings.auditNote": "Log cleansed on {date}: {count} anomalies isolated and resolved.",
  "matches.warnings.auditShow": "View details",
  "matches.warnings.bannerTitle": "This match contained {count} isolated log anomalies or legacy data.",
  "matches.warnings.chipTooltip": "{count} anomalies detected in log (click to view and resolve in Official Sheet)",
  "matches.warnings.cleanseBtn": "Cleanse & Resolve",
  "matches.warnings.cleansing": "Resolving...",
  "matches.warnings.hideDetails": "Hide details",
  "matches.warnings.resolvedSuccess": "✔ {count} anomaly/anomalies resolved and match sheet synchronized.",
  "matches.warnings.showDetails": "View list",
  "month.Abr": "Apr",
  "month.Ago": "Aug",
  "month.Dic": "Dec",
  "month.Ene": "Jan",
  "month.Feb": "Feb",
  "month.Jul": "Jul",
  "month.Jun": "Jun",
  "month.Mar": "Mar",
  "month.May": "May",
  "month.Nov": "Nov",
  "month.Oct": "Oct",
  "month.Sep": "Sep",
  "nav.admin": "ADMINISTRATION",
  "nav.dashboard": "DASHBOARD",
  "nav.equipo": "MY TEAM",
  "nav.ia": "AI GENERATOR",
  "nav.partidos": "MATCHES",
  "nav.pizarra": "TACTICAL BOARD",
  "nav.planificacion": "PLANNING",
  "nav.sesiones": "SESSIONS",
  "nav.tests": "TESTS",
  "notifPrefs.chatDesc": "Alerts for new messages in team squad chat",
  "notifPrefs.chatTitle": "Team Messages",
  "notifPrefs.errorToast": "Error saving notification preferences",
  "notifPrefs.frequencyCapDesc": "Maximum number of notifications per day",
  "notifPrefs.frequencyCapTitle": "Frequency Cap",
  "notifPrefs.matchDesc": "Alerts for call-up rosters, schedules and upcoming matches",
  "notifPrefs.matchTitle": "Match & Call-ups",
  "notifPrefs.perDay": "per day",
  "notifPrefs.quietHoursDesc": "Do not receive push notifications during this time window",
  "notifPrefs.quietHoursEnd": "Quiet end time",
  "notifPrefs.quietHoursStart": "Quiet start time",
  "notifPrefs.quietHoursTitle": "Quiet Hours",
  "notifPrefs.reminderTime": "Reminder Time",
  "notifPrefs.savedToast": "Notification preferences saved successfully",
  "notifPrefs.title": "Notification Preferences",
  "notifPrefs.wellnessDesc": "Daily reminder to fill out your health form",
  "notifPrefs.wellnessTitle": "Wellness Check-in",
  "notifications.empty": "You have no pending notifications.",
  "notifications.individualPlanAssigned": "Individual plan assigned successfully",
  "notifications.individualPlanRemoved": "Individual plan removed",
  "notifications.newExerciseSaved": "New exercise saved: {name}",
  "notifications.newMatchRegistered": "New match registered vs {opponent}",
  "notifications.newPlayerAdded": "New player added: {name}",
  "notifications.newSessionCreated": "New session created: {title}",
  "notifications.predefinedExerciseError": "You cannot delete a system predefined exercise.",
  "notifications.sessionImportedSuccess": "Session \"{title}\" imported successfully",
  "notifications.teamPlanAssigned": "Team plan assigned successfully",
  "notifications.teamPlanRemoved": "Team plan removed",
  "notifications.timeHoursAgo": "{hours} hours ago",
  "notifications.timeJustNow": "Just now",
  "notifications.timeMinAgo": "{min} min ago",
  "notifications.timeNow": "Now",
  "notifications.title": "Notifications",
  "notifications.weeklyReportReady": "📋 Your weekly team report is ready. Download it from the main panel!",
  "page.admin": "ADMINISTRATION",
  "page.dashboard": "DASHBOARD",
  "page.default": "Mister11",
  "page.equipo": "MY TEAM",
  "page.ia": "AI GENERATOR",
  "page.partidos": "MATCHES",
  "page.pizarra": "TACTICAL BOARD",
  "page.planificacion": "PLANNING",
  "page.sesiones": "SESSIONS",
  "page.tests": "TESTS",
  "partidos.tab.analisis": "Analysis",
  "partidos.tab.lista": "Matches",
  "paywall.androidBackToInfo": "Back",
  "paywall.androidDialogText": "Subscriptions are centrally managed on our web platform. Visit mister11.app to purchase your plan and get instant access in this app.",
  "paywall.androidDialogTitle": "Mister11 PRO Plans",
  "paywall.androidHaveCode": "I already have a code",
  "paywall.androidNotNow": "Not now",
  "paywall.androidOpenWeb": "Open mister11.app",
  "paywall.androidRedeemDesc": "Enter your corporate or promotional code to activate your PRO plan instantly.",
  "paywall.androidRedeemTitle": "Redeem Code",
  "paywall.benefit1": "Unlimited training sessions",
  "paywall.benefit2": "Unlimited AI task generator",
  "paywall.benefit3": "Export technical reports in PDF",
  "paywall.benefit4": "Advanced statistics and metrics suite",
  "paywall.clubBadge": "CLUB PLAN",
  "paywall.freeLimitMsg": "You have reached the free plan limit.",
  "paywall.proBadge": "PRO PLAN",
  "paywall.promoPlaceholder": "Code (e.g. BETA2026)",
  "paywall.promoSectionDesc": "Enter your code (e.g. BETA2026) to activate access immediately.",
  "paywall.promoSectionTitle": "🔑 Have a promo or beta trial code?",
  "paywall.title": "Unlock Full Potential",
  "paywall.upgradeBtn": "Upgrade to PRO",
  "paywall.upgradeClubBtn": "View CLUB Plans",
  "placeholder.teamName": "e.g. Manchester Youth A",
  "plan.category": "CATEGORY",
  "plan.categoryPlaceholder": "e.g.: Under-14 A",
  "plan.chip.compet": "Compet.",
  "plan.chip.sessions": "Sessions",
  "plan.chip.work": "Work",
  "plan.coach": "COACH",
  "plan.coachPlaceholder": "Coach name",
  "plan.dateRange": "DATE RANGE",
  "plan.days.friday": "F",
  "plan.days.monday": "M",
  "plan.days.saturday": "S",
  "plan.days.sunday": "S",
  "plan.days.thursday": "T",
  "plan.days.tuesday": "T",
  "plan.days.wednesday": "W",
  "plan.end": "End",
  "plan.exportPdf": "EXPORT PDF",
  "plan.fatigaWarning": "⚠️ Training on MD-1 — potential fatigue",
  "plan.matchDay": "⚽ Match Day:",
  "plan.meso.backToMeso": "← Back to Mesocycles",
  "plan.meso.competition": "COMPETITION",
  "plan.meso.exportPdf": "Export month to PDF",
  "plan.meso.load": "LOAD",
  "plan.meso.month": "MONTH",
  "plan.meso.monthDetail": "Month Detail: ",
  "plan.meso.predominantType": "PREDOMINANT TYPE",
  "plan.meso.sessions": "SESSIONS",
  "plan.meso.totalVolume": "TOTAL VOLUME",
  "plan.meso.weeks": "Weeks",
  "plan.metricSessions": "SESSIONS",
  "plan.metrics.macrocycle": "MACROCYCLE",
  "plan.metrics.mesocycle": "MESOCYCLE",
  "plan.metrics.mesocyclesOverview": "MESOCYCLES (OVERVIEW)",
  "plan.micro.matchDayLabel": "🏆 Match Day",
  "plan.micro.physical": "Physical",
  "plan.micro.rest": "Rest",
  "plan.micro.selectWeek": "SELECT WEEK",
  "plan.micro.sessionLabel": "Session ({duration} min)",
  "plan.micro.tactical": "Tactical",
  "plan.micro.technical": "Technical",
  "plan.micro.week": "Week",
  "plan.obj.mental": "MENTAL OBJECTIVE",
  "plan.obj.mentalPlaceholder": "Develop focus and teamwork under pressure...",
  "plan.obj.physical": "PHYSICAL OBJECTIVE",
  "plan.obj.physicalPlaceholder": "Improve aerobic endurance and reaction speed...",
  "plan.obj.seasonGeneral": "SEASON GENERAL OBJECTIVE",
  "plan.obj.seasonGeneralPlaceholder": "Describe the main goal of the season...",
  "plan.obj.tactical": "TACTICAL OBJECTIVE",
  "plan.obj.tacticalPlaceholder": "Master high pressing and build-up play...",
  "plan.obj.technical": "TECHNICAL OBJECTIVE",
  "plan.obj.technicalPlaceholder": "Improve ball control and passing in tight spaces...",
  "plan.pdf.error": "Error exporting PDF.",
  "plan.pdf.exported": "PDF exported ✓",
  "plan.period.comp": "Comp",
  "plan.period.prep": "Prep",
  "plan.period.trans": "Trans",
  "plan.reschedule.body": "The match day selected for this week is {day}. Upon confirmation, the {count} training days will be automatically adjusted to balance load before the match.",
  "plan.reschedule.confirm": "Confirm Reschedule",
  "plan.reschedule.title": "Reschedule training days?",
  "plan.reschedule.toastSuccess": "✓ Trainings rescheduled based on MD",
  "plan.reubicarBtn": "🔄 Reschedule training based on new day",
  "plan.save": "SAVE",
  "plan.saving": "SAVING...",
  "plan.seasonObjective": "OVERALL SEASON OBJECTIVE",
  "plan.seasonObjectivePlaceholder": "Enter the overall season objective...",
  "plan.seasonVolume": "SEASON VOLUME",
  "plan.sessionDuration": "Session duration:",
  "plan.start": "Start",
  "plan.strategicPlanning": "STRATEGIC PLANNING",
  "plan.tab.macrociclo": "MACROCYCLE",
  "plan.tab.mesociclo": "MESOCYCLE",
  "plan.tab.microciclo": "MICROCYCLE",
  "plan.tab.objetivos": "OBJECTIVES",
  "plan.totalMinutesLabel": "total minutes",
  "plan.trainingDays": "TRAINING DAYS",
  "plan.volumeUnit": "min/wk",
  "planning.generating_pdf": "Generating mesocycle PDF...",
  "planning.generating_pdf_generic": "Generating PDF...",
  "planning.login_required": "Sign in to save",
  "planning.matrix.daysPerWeek": "days/wk",
  "planning.matrix.loadDynamics": "LOAD DYNAMICS",
  "planning.matrix.matchDay": "MATCH DAY",
  "planning.matrix.microType": "MICRO TYPE",
  "planning.matrix.microcycleNo": "MICROCYCLE NO.",
  "planning.matrix.months": "MONTHS",
  "planning.matrix.pctPhysical": "% PHYSICAL",
  "planning.matrix.pctTactical": "% TACTICAL",
  "planning.matrix.pctTechnical": "% TECHNICAL",
  "planning.matrix.periods": "PERIODS",
  "planning.matrix.physicalTest": "PHYSICAL TEST",
  "planning.matrix.savePlanning": "SAVE PLANNING",
  "planning.matrix.sessions": "SESSIONS",
  "planning.matrix.title": "PLANNING MATRIX",
  "planning.matrix.volumeMin": "VOLUME (MIN)",
  "planning.microType.ajuste": "Adjustment",
  "planning.microType.carga": "Load",
  "planning.microType.choque": "Shock",
  "planning.microType.comp": "Comp",
  "planning.microType.recup": "Recovery",
  "planning.pdf_error": "Error exporting PDF.",
  "planning.pdf_exported": "PDF exported ✓",
  "planning.pdf_month_not_found": "Error: Month information not found.",
  "planning.pdf_success": "Mesocycle PDF generated successfully ✓",
  "planning.save_error": "Error saving.",
  "planning.saved": "Planning saved ✓",
  "plans.assignModal.ageBlocked": "Not suitable for player's age",
  "plans.assignModal.assignBtn": "Assign Plan",
  "plans.assignModal.frequency": "Frequency",
  "plans.assignModal.homeAlternative": "Home alternative",
  "plans.assignModal.minAge": "Min. safe age",
  "plans.assignModal.planName": "Plan Name (optional)",
  "plans.assignModal.preferredMaterial": "Preferred equipment",
  "plans.assignModal.reason": "Reason",
  "plans.assignModal.searchPlaceholder": "Search exercise...",
  "plans.assignModal.selectExercises": "Select Exercises",
  "plans.assignModal.supervisionRequired": "In-person supervision required",
    "exercise.illustrationPending": "Illustration pending — follow textual description",
  "exercise.illustrationNotice": "Clinical protocol: ongoing technical validation without synthetic AI generation",
  "exercise.coachingPoints": "Key execution points",
  "exercise.minSafeAge": "Min. safe age",
  "exercise.preferredMaterial": "Preferred equipment",
  "exercise.homeAlternative": "Home alternative",
  "exercise.supervisionRequired": "In-person supervision required",
  "plans.assignModal.title": "Assign Exercise Plan",
  "plans.assignedPlan": "Assigned Plan",
  "plans.badgeIndividual": "INDIVIDUAL",
  "plans.badgeTeam": "TEAM",
  "plans.coachFeedback": "Coach Instructions",
  "plans.copyLink": "COPY LINK",
  "plans.daily": "Daily",
  "plans.exercisesHeader": "Today's Exercises",
  "plans.linkCopied": "LINK COPIED!",
  "plans.loadingPlans": "Loading plans...",
  "plans.noPlansAssigned": "The player has no assigned plans.",
  "plans.recommendExercises": "Recommend Exercises",
  "plans.routinesAndPrevention": "Routines & Prevention",
  "plans.shareNotice": "Share this link with your players so they can view their exercise plan without logging in:",
  "plans.sharePlan": "🔗 Share Plan",
  "plans.streakDays.one": "Streak: {count} day",
  "plans.streakDays.other": "Streak: {count} days",
  "player.achievements.bronzeBadge": "25 XP · Weekly Challenge",
  "player.achievements.completed": "Completed!",
  "player.achievements.filterAll": "All ({count})",
  "player.achievements.filterBiweekly": "Bi-weekly (Silver)",
  "player.achievements.filterBronze": "Bronze ({count})",
  "player.achievements.filterGold": "Gold ({count})",
  "player.achievements.filterSeason": "Season (Gold)",
  "player.achievements.filterSilver": "Silver ({count})",
  "player.achievements.filterWeekly": "Weekly (Bronze)",
  "player.achievements.goldBadge": "100 XP · Season Milestone (Max)",
  "player.achievements.inProgress": "{percent}% completed",
  "player.achievements.intentionOnlyNote": "(Intention challenge)",
  "player.achievements.loading": "Loading achievements showcase...",
  "player.achievements.noSessions": "No sessions scheduled this week",
  "player.achievements.pendingActa": "Pending match sheet",
  "player.achievements.season": "Season 2026-27 · Youth Football",
  "player.achievements.seasonPeriod": "Season 2026-27",
  "player.achievements.silverBadge": "50 XP · Bi-weekly Challenge",
  "player.achievements.subtabJuegos": "Games & Challenges",
  "player.achievements.subtabRanking": "Ranking",
  "player.achievements.subtabVitrina": "Showcase",
  "player.achievements.thisFortnight": "This fortnight",
  "player.achievements.thisWeek": "This week",
  "player.achievements.tierBronze": "Bronze",
  "player.achievements.tierGold": "Gold",
  "player.achievements.tierSilver": "Silver",
  "player.achievements.title": "Your Sporting Achievements",
  "player.achievements.titleParent": "Achievements of {name}",
  "player.achievements.unlocked": "Unlocked",
  "player.achievements.xpSubtitle": "Earned by completing challenges",
  "player.achievements.xpTitle": "Achievement XP",
  "player.addPlayer": "+ Add Player",
  "player.age": "Age",
  "player.assists": "Assists",
  "player.attendance.absent": "Absent",
  "player.attendance.excused": "Excused",
  "player.attendance.injured": "Injured",
  "player.attendance.monthlyTitle": "Monthly Attendance Record",
  "player.attendance.present": "Present",
  "player.attendance.rate": "Annual Attendance Rate",
  "player.avgRating": "Average Rating",
  "player.bmi": "BMI",
  "player.bothFeet": "Both / Ambidextrous",
  "player.cards": "Cards",
  "player.category": "Category",
  "player.chat.block.btn": "Yes, Block",
  "player.chat.block.confirm": "Are you sure you want to block communication with {name}? Neither party will be able to send private messages until unblocked.",
  "player.chat.block.success": "User blocked successfully.",
  "player.chat.block.title": "Block user?",
  "player.chat.block_error": "Error blocking user.",
  "player.chat.blocked.banner": "🚫 Communication in this private chat is blocked.",
  "player.chat.blocked.unblockHint": "You can manage blocked users in Profile > Privacy.",
  "player.chat.coachSender": "👑 Coaching Staff",
  "player.chat.emptyDesc": "Send a message or tap one of the quick replies above.",
  "player.chat.emptyTitle": "No messages in this channel yet.",
  "player.chat.headerSubtitle": "{team} · Private and confidential messages",
  "player.chat.headerTitle": "Direct Channel with Coaching Staff",
  "player.chat.loading": "Loading conversation...",
  "player.chat.menu.block": "Block user",
  "player.chat.menu.copied": "Text copied to clipboard",
  "player.chat.menu.copy": "Copy text",
  "player.chat.menu.report": "Report message",
  "player.chat.moderation.badge": "Reports",
  "player.chat.moderation.deleteConfirm": "Permanently delete this message from the chat?",
  "player.chat.moderation.deleteMsg": "Delete message",
  "player.chat.moderation.empty": "No pending reported messages.",
  "player.chat.moderation.msgDeleted": "Message deleted from chat.",
  "player.chat.moderation.resolve": "Mark as resolved",
  "player.chat.moderation.resolved": "Report marked as resolved.",
  "player.chat.moderation.title": "Message Moderation",
  "player.chat.now": "Just now",
  "player.chat.optionsAria": "Message options",
  "player.chat.placeholder": "Write a message to the coach...",
  "player.chat.placeholderCoach": "Write a reply to {name}...",
  "player.chat.playerSender": "👤 Player",
  "player.chat.qr.coachEarly": "⏰ Remember to arrive 15 min early",
  "player.chat.qr.coachReceived": "👍 Received, see you on the pitch",
  "player.chat.qr.coachRest": "🩺 Rest and let me know if pain persists",
  "player.chat.qr.coachSquad": "📋 Squad confirmed, all the best!",
  "player.chat.qr.discomfort": "🩺 I have muscle soreness",
  "player.chat.qr.late10": "🏃 Running 10 min late",
  "player.chat.qr.ready": "✅ All set for the match",
  "player.chat.qr.talk": "❓ Coach, can I speak with you?",
  "player.chat.qr.transport": "🚗 I need transport for the away match",
  "player.chat.quickMsg.injury": "I have a muscle discomfort and cannot train at 100%.",
  "player.chat.quickMsg.late": "I will be 5 minutes late.",
  "player.chat.quickMsg.ready": "Ready for this weekend match!",
  "player.chat.quickMsg.study": "I cannot attend due to study / exam commitments.",
  "player.chat.quickReplies": "⚡ Quick replies:",
  "player.chat.quickTitle": "Quick Messages:",
  "player.chat.report.detailsPlaceholder": "Add any additional details (optional)...",
  "player.chat.report.quotedMessage": "Reported message:",
  "player.chat.report.reason.harassment": "Harassment, bullying or misconduct",
  "player.chat.report.reason.inappropriate": "Inappropriate content or offensive language",
  "player.chat.report.reason.other": "Other reason",
  "player.chat.report.reason.spam": "Spam or unwanted messages",
  "player.chat.report.selectReason": "Select a reason:",
  "player.chat.report.submit": "Submit Report",
  "player.chat.report.submitting": "Submitting...",
  "player.chat.report.subtitle": "We review all reports to ensure a safe and respectful environment.",
  "player.chat.report.success": "Report submitted successfully. Staff will review this message.",
  "player.chat.report.title": "Report Message",
  "player.chat.report_error": "Error sending report.",
  "player.chat.send": "Send",
  "player.chat.sendAria": "Send message",
  "player.chat.title": "Chat with Coach",
  "player.chat.unblock.btn": "Unblock",
  "player.chat.unblock.confirm": "Do you want to unblock {name} and resume messaging?",
  "player.chat.unblock.success": "User unblocked.",
  "player.closeProfile": "Close profile",
  "player.coachRating": "Coach Rating",
  "player.deleteConfirm": "Are you sure you want to remove {name} from the team?",
  "player.deleteFromTeam": "Remove {name} from Team",
  "player.editProfile": "Edit Profile",
  "player.foot": "Dominant Foot",
  "player.foot.both": "Both",
  "player.foot.left": "Left",
  "player.foot.right": "Right",
  "player.goalAbbr": "GOAL",
  "player.goals": "GOALS",
  "player.height": "Height",
  "player.heightAbbr": "Ht",
  "player.home.almostBronze": "ACHIEVEMENT ALMOST UNLOCKED! (BRONZE)",
  "player.home.almostGold": "ACHIEVEMENT ALMOST UNLOCKED! (GOLD)",
  "player.home.almostSilver": "ACHIEVEMENT ALMOST UNLOCKED! (SILVER)",
  "player.home.announcements": "Team Notice Board",
  "player.home.closestAchievement": "Next Challenge",
  "player.home.goals": "MATCH GOALS",
  "player.home.goalsSub": "{goals} in {matches} ({minutes}')",
  "player.home.goalsSummary": "{goals} in {matches} ({minutes}')",
  "player.home.greeting": "Hello, {name}!",
  "player.home.nextChallenge": "NEXT CHALLENGE",
  "player.home.nextEventBadge": "NEXT CALL-UP",
  "player.home.nextMatch": "Next Call-up",
  "player.home.noAnnouncements": "No recent announcements from coach.",
  "player.home.noUpcoming": "No training sessions scheduled for the coming days.",
  "player.home.rsvpBtn": "Confirm Attendance (RSVP)",
  "player.home.rsvpPrompt": "Will you attend this session?",
  "player.home.scheduled": "SCHEDULED",
  "player.home.soon": "Coming soon",
  "player.home.streak": "ATTENDANCE STREAK",
  "player.home.streakSession": "{count} consecutive session",
  "player.home.streakSessions": "{count} consecutive sessions",
  "player.home.streakSub": "{count} in a row",
  "player.home.subtitle": "Everything set for your next training.",
  "player.home.viewDetails": "View Details",
  "player.home.viewSchedule": "View Full Schedule",
  "player.leaderboard.accumulatedXP": "{xp} accumulated XP",
  "player.leaderboard.challenges": "challenges",
  "player.leaderboard.colMetric": "METRIC",
  "player.leaderboard.colPlayer": "TEAMMATE",
  "player.leaderboard.colRank": "RANK",
  "player.leaderboard.colXP": "TOTAL XP",
  "player.leaderboard.footerDesc": "Commitment in training and teamwork are the path to rank up in Mister11.",
  "player.leaderboard.footerTitle": "Every session counts for the team!",
  "player.leaderboard.leadingTeam": "👑 Leading team standings!",
  "player.leaderboard.matchesPlayedShort": "MP",
  "player.leaderboard.protectedData": "Protected team data",
  "player.leaderboard.subtitle": "Earn XP with your training attendance, minutes played and completed challenges.",
  "player.leaderboard.tabAchievements": "Achievements",
  "player.leaderboard.tabAttendance": "Attendance",
  "player.leaderboard.tabGlobal": "Global XP",
  "player.leaderboard.tabMatches": "Matches & Minutes",
  "player.leaderboard.tierTag": "Tier {tier}",
  "player.leaderboard.title": "TEAM PERFORMANCE LEADERBOARD",
  "player.leaderboard.xpDiff": "Only {xp} XP away from Top #{rank}!",
  "player.leaderboard.youChip": "YOU",
  "player.leaderboard.yourRank": "Your Position:",
  "player.leftFoot": "Left",
  "player.linkedAccount": "Linked Account",
  "player.matchHistory": "Match History",
  "player.matchHistoryEmpty": "No matches recorded for this player.",
  "player.matches": "MATCHES",
  "player.matchesAbbr": "MP",
  "player.minutes": "MINUTES",
  "player.minutesPlayed": "Minutes played",
  "player.nav.achievements": "Achievements",
  "player.nav.chat": "Coach",
  "player.nav.home": "Home",
  "player.nav.profile": "Profile",
  "player.nav.schedule": "Schedule",
  "player.nav.stats": "Stats",
  "player.nav.tests": "Tests",
  "player.noAccount": "No linked account (edit profile to add)",
  "player.noLinkedAccount": "No linked account",
  "player.notifications.promptBtn": "TURN ON ALERTS",
  "player.notifications.promptDesc": "Instantly get official match squads and reminders two hours before each practice.",
  "player.notifications.promptLater": "Later",
  "player.notifications.promptTitle": "Would you like to turn on squad and match alerts?",
  "player.openChat": "Open Chat with player",
  "player.plans.completeExercise": "Mark as completed",
  "player.plans.completedExercise": "Exercise completed!",
  "player.plans.error": "Error",
  "player.plans.noPlans": "You have no active plans assigned",
  "player.plans.posturalKey": "Postural Key",
  "player.plans.prevention": "Injury Prevention",
  "player.plans.reps": "Reps",
  "player.plans.rest": "Rest",
  "player.plans.sets": "Sets",
  "player.plans.stepByStep": "STEP-BY-STEP EXECUTION",
  "player.plans.subtitle": "Custom routines assigned by coaching staff",
  "player.plans.title": "Individual Training Plans",
  "player.portal.activeCard": "Active profile:",
  "player.portal.family": "FAMILY PORTAL",
  "player.portal.joinWithCode": "Join a Team with Code",
  "player.portal.loading": "Loading your player portal...",
  "player.portal.logoutAria": "Log Out or Switch Account",
  "player.portal.myTeam": "My Team",
  "player.portal.notLinkedDesc": "You are not linked to any team as a player yet. Ask your coach for the access code or tap below to join your squad.",
  "player.portal.notLinkedTitle": "Hello, {name}!",
  "player.portal.parentView": "Parent View",
  "player.portal.player": "PLAYER PORTAL",
  "player.portal.selectTeamAria": "Select player team",
  "player.portal.settingsAria": "Settings & Preferences",
  "player.portal.switchToCoach": "Switch to Coach Mode",
  "player.portal.themeDarkAria": "Switch to dark mode",
  "player.portal.themeLightAria": "Switch to light mode",
  "player.primaryPosition": "Primary Position",
  "player.profile.account": "Access Account",
  "player.profile.account_deleted": "Your account has been deleted successfully.",
  "player.profile.activeCard": "Active Player:",
  "player.profile.age": "Age",
  "player.profile.attendance": "ATTENDANCE",
  "player.profile.blockedUsers": "Blocked Users",
  "player.profile.bmi": "BMI",
  "player.profile.bodyComp": "📊 Body Composition",
  "player.profile.bodyCompDesc": "Anthropometric parameters are monitored periodically by the coaching staff to optimize your fitness plan.",
  "player.profile.category": "Category",
  "player.profile.consentClearSign": "Clear signature",
  "player.profile.consentDrawLabel": "Parent / Guardian Signature (touch or mouse):",
  "player.profile.consentHealthCheck": "Health & Wellness Data: I authorize daily wellness check-ins and muscle soreness tracking solely for injury prevention purposes.",
  "player.profile.consentModalDesc": "In accordance with the GDPR, the parent or legal guardian can authorize or deny the following data processing for the minor:",
  "player.profile.consentModalTitle": "Digital Parental Consent",
  "player.profile.consentParentNameLabel": "Parent / Guardian's Full Name *",
  "player.profile.consentPending": "Pending Signature",
  "player.profile.consentSaveSign": "Confirm and Save Signature",
  "player.profile.consentSaving": "Saving...",
  "player.profile.consentSigned": "Signed and Valid",
  "player.profile.consentStatus": "Parental Consent Status",
  "player.profile.consentTestsCheck": "Tests & Performance: I authorize autonomous fitness testing (speed, jump, endurance) for technical tracking.",
  "player.profile.consent_error": "Error saving consent.",
  "player.profile.consent_saved": "Parental consent updated successfully.",
  "player.profile.deleteAccount": "Delete Account & Data (GDPR)",
  "player.profile.deleteAccountDesc": "This action is permanent and irreversible. Your user access, sports history, consents, and profile in Mister11 will be deleted.",
  "player.profile.deleteAccountTitle": "Delete your account?",
  "player.profile.deleteConfirmBtn": "Yes, Delete Account",
  "player.profile.deleteConfirmPrompt": "Type DELETE to confirm:",
  "player.profile.deleteConfirmWord": "DELETE",
  "player.profile.deleteDeleting": "Deleting...",
  "player.profile.discomfortQuestion": "2. Do you have any discomfort or muscle pain?",
  "player.profile.discomfortZone": "Discomfort zone:",
  "player.profile.dorsal": "SQUAD NUMBER",
  "player.profile.foot": "Dominant foot",
  "player.profile.general": "GENERAL",
  "player.profile.goals": "Goals",
  "player.profile.hasDiscomfort": "🟡 I have discomfort",
  "player.profile.health": "HEALTH",
  "player.profile.height": "Height",
  "player.profile.logout": "Log Out",
  "player.profile.matches": "Matches",
  "player.profile.minutes": "Minutes",
  "player.profile.moodQuestion": "3. Mood and energy level today? (1 = Low, 5 = Peak)",
  "player.profile.noBlockedUsers": "You do not have any blocked users.",
  "player.profile.noDiscomfort": "🟢 No discomfort",
  "player.profile.parentBadge": "Family / Guardian View",
  "player.profile.parent_name_required": "Please enter the parent/guardian name.",
  "player.profile.physical": "PHYSICAL",
  "player.profile.plans": "PLANS",
  "player.profile.position": "Main Position",
  "player.profile.sendWellness": "Save Health Check-in",
  "player.profile.signConsent": "Sign / Edit Consent",
  "player.profile.sleepQuestion": "1. How did you sleep and recover? (1 = Very poor, 5 = Excellent)",
  "player.profile.switchToCoach": "Switch to Coach Mode",
  "player.profile.weight": "Weight",
  "player.profile.wellnessCheckin": "DAILY WELLNESS CHECK-IN",
  "player.profile.wellnessSent": "You have already submitted today's check-in! You can update it if your feelings change.",
  "player.profile.wellness_saved": "Wellness check-in saved successfully!",
  "player.profile.years": "years old",
  "player.rightFoot": "Right",
  "player.schedule.attendance_error": "Error saving attendance.",
  "player.schedule.backToCurrentMonth": "Back to current month",
  "player.schedule.calledBadge": "📋 Called up",
  "player.schedule.calledUp": "Called up",
  "player.schedule.calledUpDesc": "You have been selected by the coaching staff. Give 100% on the pitch!",
  "player.schedule.coachRating": "Coach Rating:",
  "player.schedule.emptyDesc": "Your coach has not scheduled sessions or matches for this month yet.",
  "player.schedule.match": "MATCH",
  "player.schedule.minPlayed": "min played",
  "player.schedule.noEvents": "No events scheduled for this month.",
  "player.schedule.noMinutes": "No minutes",
  "player.schedule.notCalled": "Not called up for this match",
  "player.schedule.notCalledDesc": "Keep working hard in training!",
  "player.schedule.pendingVerification": "Pending verification",
  "player.schedule.promptParent": "Will {name} attend this event?",
  "player.schedule.promptSelf": "Will you attend this session?",
  "player.schedule.reserve": "Standby / Reserve list",
  "player.schedule.reserveDesc": "Stay tuned in case of last minute updates.",
  "player.schedule.rsvpConfirmed": "Attendance confirmed: \"{status}\"",
  "player.schedule.rsvpGoing": "Going",
  "player.schedule.rsvpJustified": "Excused",
  "player.schedule.rsvpLate": "Arriving late",
  "player.schedule.rsvpNotGoing": "Not going",
  "player.schedule.starter": "Starter",
  "player.schedule.substitute": "Substitute",
  "player.schedule.title": "Team Schedule",
  "player.schedule.training": "TRAINING",
  "player.settings.dangerZone": "Privacy Zone (GDPR)",
  "player.settings.deleteAccountDesc": "Permanently delete your profile and personal records.",
  "player.settings.installApp": "Install App (PWA)",
  "player.settings.installAppDesc": "Add Mister11 to your home screen for fast native access.",
  "player.settings.language": "App Language",
  "player.settings.modalTitle": "Settings & Preferences",
  "player.settings.notifications": "Session Reminders",
  "player.settings.notificationsDesc": "Receive reminders 1 hour before training and matches.",
  "player.settings.sessionTitle": "Session & Account",
  "player.settings.switchModeTitle": "Role & Permissions",
  "player.settings.theme": "Dark Mode",
  "player.shareConsent": "Share Parental Consent",
  "player.starter": "Starter",
  "player.stats.aboveAvg": "▲ +{xp} XP (Above average)",
  "player.stats.anonymousRgpd": "🔒 Anonymous data (GDPR)",
  "player.stats.areasInZero": "Areas pending measurement",
  "player.stats.areasInZeroDesc": "The Mental area is activated by completing questionnaires in the Tests tab. Physical, Technical, and Tactical areas are updated with coach evaluations.",
  "player.stats.assists": "ASSISTS",
  "player.stats.average": "Average:",
  "player.stats.avgRating": "AVG RATING",
  "player.stats.axis.attendance": "ATTENDANCE",
  "player.stats.axis.mental": "MENTAL",
  "player.stats.axis.physical": "PHYSICAL",
  "player.stats.axis.tactical": "TACTICAL",
  "player.stats.axis.technical": "TECHNICAL",
  "player.stats.belowAvg": "▼ +{xp} XP (Below average)",
  "player.stats.cards": "CARDS",
  "player.stats.disciplinarySanctions": "Disciplinary sanctions",
  "player.stats.evolutionTitle": "Test Evolution Over Time",
  "player.stats.friendlyMatch": "Friendly",
  "player.stats.globalXpSubtitle": "Attendance + minutes + achievements",
  "player.stats.globalXpTitle": "Global XP",
  "player.stats.goToTests": "Go to Questionnaires",
  "player.stats.goals": "GOALS",
  "player.stats.hideGuide": "Hide guide",
  "player.stats.hideInfo": "Hide info",
  "player.stats.howAxesMeasured": "How is each axis measured?",
  "player.stats.howIsMeasured": "How is this measured?",
  "player.stats.howIsMeasuredDesc": "Attendance and minutes are extracted from official match sheets in strict compliance with GDPR.",
  "player.stats.inCompetition": "in competition",
  "player.stats.inMatch": "in {count} match",
  "player.stats.inMatches": "in {count} matches",
  "player.stats.keyPasses": "key passes",
  "player.stats.leaderboardSubtitle": "Score and commitment in the locker room",
  "player.stats.leaderboardTitle": "Squad Leaderboard",
  "player.stats.makeTest": "Take test",
  "player.stats.matchHistory": "OFFICIAL MATCH HISTORY",
  "player.stats.matchHistorySync": "Synced with coach match sheets",
  "player.stats.minutesPerMatch": "Minutes per match",
  "player.stats.minutesPlayed": "MINUTES",
  "player.stats.noAttRecorded": "● No sessions recorded yet",
  "player.stats.noEvalsDesc": "Complete tests in the Tests tab or wait for coach assessments to see your progression charts.",
  "player.stats.noEvalsYet": "No evaluations recorded yet",
  "player.stats.noMatchesDesc": "Your minutes, goals, and call-ups will appear here automatically after each match.",
  "player.stats.noMatchesRecorded": "● No matches played yet",
  "player.stats.noMatchesYet": "No matches recorded yet this season",
  "player.stats.noTeamDataDesc": "Comparative metrics will automatically activate when coach logs attendance or matches.",
  "player.stats.noTeamDataYet": "● Not enough squad data yet",
  "player.stats.officialMatch": "Official",
  "player.stats.officialMatches": "MATCHES",
  "player.stats.officialRating": "Official Rating",
  "player.stats.officialSummaryTitle": "OFFICIAL STATS 2026-27",
  "player.stats.onAvg": "● +{xp} XP (On average)",
  "player.stats.pendingActaShort": "Pending match sheet",
  "player.stats.radarAtt": "Attendance: Real attendance rate from training sessions and call-ups.",
  "player.stats.radarGuideTitle": "Data source for each dimension (0 to 100):",
  "player.stats.radarLevel": "Global Level: {level}",
  "player.stats.radarMental": "Mental: Psychological questionnaires (ACSI-28, MTQ-10), cognitive game training and coaching staff rating.",
  "player.stats.radarPhys": "Physical: Fitness tests (endurance, speed, power) or coach physical grade.",
  "player.stats.radarTact": "Tactical: Positioning, decision making and game reading evaluated by coach.",
  "player.stats.radarTech": "Technical: Ball control, passing, dribbling and finishing evaluated by coach.",
  "player.stats.radarTitle": "SKILLS RADAR",
  "player.stats.realTime": "⚡ In real time",
  "player.stats.seasonAverage": "Season average",
  "player.stats.sourceAttendance": "Attendance: Sourced from official coach training logs. Grants +{xp} XP based on your attendance rate.",
  "player.stats.sourceAverage": "Squad Average: Locker room benchmark to assess your consistency without negative bias.",
  "player.stats.sourceInfoTitle": "Where do the data and XP points in this table come from?",
  "player.stats.sourceMatches": "Matches / Minutes: Sourced from official match sheets and call-ups. Grants +{xp} XP proportional to your minutes played.",
  "player.stats.startsAndSubs": "{starts} start. · {subs} sub.",
  "player.stats.title": "Stats & Performance",
  "player.stats.vsTeamTitle": "YOU VS TEAM AVERAGE",
  "player.stats.wellnessTitle": "Weekly Wellness",
  "player.stats.xpByParticipation": "+{xp} XP based on your {pct}% participation",
  "player.stats.you": "You",
  "player.substitute": "Substitute",
  "player.syncNotice": "Goals, lineups, and minutes recorded in the Matches module will automatically synchronize here.",
  "player.tab.attendance": "ATTENDANCE",
  "player.tab.chat": "CHAT",
  "player.tab.general": "GENERAL",
  "player.tab.health": "HEALTH",
  "player.tab.physical": "PHYSICAL",
  "player.tab.plans": "PLANS",
  "player.tab.settings": "SETTINGS",
  "player.weight": "Weight",
  "playerDashboard.new_message": "💬 New message from Coach:",
  "playerProfile.ageLabel": "Age",
  "playerProfile.bmi": "BMI",
  "playerProfile.bmiDesc": "Estimated Body Mass Index.",
  "playerProfile.editTooltip": "Tap to edit your measurements",
  "playerProfile.heightLabel": "Height",
  "playerProfile.heightRangeError": "Height must be between 100 and 230 cm.",
  "playerProfile.heightUnit": "cm",
  "playerProfile.physicalStats": "Physical Stats",
  "playerProfile.readOnlyNotice": "Age, shirt number and position can only be modified by coaching staff.",
  "playerProfile.saveError": "Error saving physical stats.",
  "playerProfile.statsSaved": "Physical stats updated successfully.",
  "playerProfile.weightLabel": "Weight",
  "playerProfile.weightRangeError": "Weight must be between 30 and 150 kg.",
  "playerProfile.weightUnit": "kg",
  "pos.all": "ALL",
  "pos.def": "DEF",
  "pos.del": "ST",
  "pos.ext": "W",
  "pos.ltd": "RB",
  "pos.lti": "LB",
  "pos.mc": "CM",
  "pos.mcd": "CDM",
  "pos.mco": "CAM",
  "pos.por": "GK",
  "pricing.badge.bestValueAcademies": "BEST VALUE FOR ACADEMIES",
  "pricing.badge.mostPopularCoach": "MOST POPULAR COACH",
  "pricing.billing.discountBadge": "2 MONTHS FREE",
  "pricing.billing.monthly": "Monthly",
  "pricing.billing.season": "Full Season Pass (10 Months)",
  "pricing.btn.selectClubPro": "SELECT CLUB PRO",
  "pricing.btn.selectPremium": "SELECT PREMIUM",
  "pricing.btn.selectStarter": "SELECT STARTER",
  "pricing.btn.startFree": "START FREE",
  "pricing.btn.tryPro": "TRY 7 DAYS FREE",
  "pricing.cancelAnytime": "Cancel anytime without commitment.",
  "pricing.clubPro.attr1_strong": "Up to 15 Teams",
  "pricing.clubPro.attr1_text": "Up to 10 staff per team",
  "pricing.clubPro.attr2_strong": "Consolidated Club Reports",
  "pricing.clubPro.attr3_strong": "Youth Academy Historical Hub & 24/7",
  "pricing.clubPro.vat": "~3.00 €/coach/month · VAT included",
  "pricing.coachPro": "Coach PRO",
  "pricing.comparison.subtitle": "Examine every feature in detail across individual and club plans with verified entitlements.",
  "pricing.comparison.thModule": "Module & Feature",
  "pricing.comparison.title": "Detailed Feature Comparison Matrix",
  "pricing.footer.install": "Install App / PWA",
  "pricing.footer.login": "Coach Login",
  "pricing.footer.rgpd": "GDPR & Privacy",
  "pricing.footer.rights": "All rights reserved. Official Earth and Pitch Palette.",
  "pricing.footer.tagline": "The technical intelligence platform for grassroots and amateur football.",
  "pricing.free.attr1_strong": "1 Team",
  "pricing.free.attr1_text": "(23 players) · 1 Coach",
  "pricing.free.attr2_strong": "10 Sessions",
  "pricing.free.attr2_text": "Basic board · 5 AI/month",
  "pricing.free.attr3_strong": "Digital GDPR Signatures",
  "pricing.free.attr3_text": "included",
  "pricing.freq.forever": "/ forever",
  "pricing.freq.month": "/ month",
  "pricing.freq.season": "/ season",
  "pricing.freq.seasonShort": "/ season",
  "pricing.fullAccess": "Full access to all advanced features.",
  "pricing.header.subtitle": "All prices include VAT. The season pass covers 10 months of official competition with July and August free.",
  "pricing.header.title": "Transparent Pricing for Coaches & Academies",
  "pricing.monthly": "Monthly billing",
  "pricing.plan.clubPremium.name": "Club Premium",
  "pricing.plan.clubPremium.tagline": "For high-performance and multi-site academies",
  "pricing.plan.clubPro.name": "Club PRO",
  "pricing.plan.clubPro.tagline": "For structured clubs with their own methodology",
  "pricing.plan.clubStarter.name": "Club Starter",
  "pricing.plan.clubStarter.tagline": "For growing academies and clubs",
  "pricing.plan.free.name": "Free Plan",
  "pricing.plan.free.tagline": "To start digitizing your team",
  "pricing.plan.pro.name": "PRO Plan",
  "pricing.plan.pro.tagline": "For the coach seeking maximum performance",
  "pricing.premium.attr1_strong": "Up to 40 Teams",
  "pricing.premium.attr1_text": "Unlimited Staff",
  "pricing.premium.attr2_strong": "Multi-Site Academy Licenses",
  "pricing.premium.attr3_strong": "Dedicated VIP Onboarding",
  "pricing.premium.vat": "VAT included · Dedicated VIP Support",
  "pricing.pro.attr1_strong": "Up to 3 Teams",
  "pricing.pro.attr1_text": "Unlimited Sessions & Live Stats",
  "pricing.pro.attr2_strong": "Official 7-Page PDF Report",
  "pricing.pro.attr2_text": "xG-Lite (105:68) & GK Metrics",
  "pricing.pro.attr3_strong": "Player Portal",
  "pricing.pro.attr3_text": "Daily Wellness, Tests & Unlimited AI",
  "pricing.pro.vatMonthly": "Billed monthly · Cancel anytime",
  "pricing.pro.vatSeason": "Equivalent to 6.90 €/month · VAT included",
  "pricing.starter.attr1_strong": "Up to 6 Teams",
  "pricing.starter.attr1_text": "Up to 4 staff per team",
  "pricing.starter.attr2_strong": "All PRO Features Included",
  "pricing.starter.attr3_strong": "Academy Multi-Coach Panel",
  "pricing.starter.vat": "~5.50 €/coach/month · VAT included",
  "pricing.subscribeNow": "Subscribe Now",
  "pricing.vat.included": "VAT included",
  "push.foreground_toast": "🔔 {title}: {body}",
  "qrScanner.cameraPermissionError": "Could not access camera. Please check browser permissions.",
  "qrScanner.hint": "Point your camera at the QR code provided by the coach to join the team automatically.",
  "qrScanner.noQrInImage": "No QR code detected in the selected image.",
  "qrScanner.title": "Scan Team QR Code",
  "qrScanner.unsupportedBrowser": "Your browser or device does not support camera access.",
  "qrScanner.uploadQrPhoto": "Upload QR photo",
  "rendimientoPdf.btnDownload": "Download PDF",
  "rendimientoPdf.chartsTitle": "Player Metrics Comparison",
  "rendimientoPdf.generatedBy": "Generated by Mister11",
  "rendimientoPdf.matchDetails": "Match Details",
  "rendimientoPdf.subtitle": "Individual player statistics and canonical metrics",
  "rendimientoPdf.tableTitle": "Complete Performance Table",
  "rendimientoPdf.title": "INDIVIDUAL PERFORMANCE REPORT",
  "sector.activeZone": "Active Zone: {zone}",
  "sesiones.actions.edit": "Edit",
  "sesiones.actions.share": "Share",
  "sesiones.blockCount.one": "{count} Block",
  "sesiones.blockCount.other": "{count} Blocks",
  "sesiones.categories.all": "All",
  "sesiones.categories.fisica": "Physical",
  "sesiones.categories.general": "General",
  "sesiones.categories.mixta": "Mixed",
  "sesiones.categories.partido": "Match",
  "sesiones.categories.tactica": "Tactical",
  "sesiones.categories.tecnica": "Technical",
  "sesiones.clickDayToView": "Click a day to view sessions",
  "sesiones.exportICS": "📅 Export ICS",
  "sesiones.fieldMode": "Field Mode",
  "sesiones.importSession": "Import Session",
  "sesiones.newSession": "+ New Session",
  "sesiones.noDiagram": "No diagram",
  "sesiones.preview.addBlock": "+ Add Block",
  "sesiones.preview.blocks": "BLOCKS",
  "sesiones.preview.deleteAnimation": "DELETE",
  "sesiones.preview.deleteSession": "Delete Session",
  "sesiones.preview.editSession": "✏️ Edit Session",
  "sesiones.preview.emptyBlocks": "No blocks defined.",
  "sesiones.preview.exportMp4": "🎬 EXPORT MP4",
  "sesiones.preview.exportPdf": "📄 Export to PDF",
  "sesiones.preview.generating": "⏳ Generating report...",
  "sesiones.preview.googleCal": "📅 Google Cal",
  "sesiones.preview.ics": "📥 ICS",
  "sesiones.preview.load": "LOAD",
  "sesiones.preview.min": "MIN",
  "sesiones.preview.shareSession": "🔗 Share / Transfer Session",
  "sesiones.preview.startLiveField": "⏱️ Start Live Field Mode (Timer & Voice)",
  "sesiones.preview.structure": "Session Structure",
  "sesiones.preview.viewPdf": "View PDF",
  "sesiones.tab.animations": "Animations",
  "sesiones.tab.captures": "Captures",
  "sesiones.tab.sessions": "Sessions",
  "sesiones.title": "Training Sessions",
  "sesiones.views.day": "DAY",
  "sesiones.views.month": "MONTH",
  "sesiones.views.week": "WEEK",
  "session.untitled": "Untitled",
  "sessionRating.averageRating": "Avg",
  "sessionRating.commentPlaceholder": "Coaching notes or feedback (optional, max 200 chars)",
  "sessionRating.evolutionTitle": "Training Evolution",
  "sessionRating.noRatings": "No ratings recorded for this session yet.",
  "sessionRating.performanceTableSubtitle": "Last 5 rated sessions and accumulated average",
  "sessionRating.performanceTableTitle": "Training Performance",
  "sessionRating.radarAxisTraining": "Training",
  "sessionRating.rateButton": "Rate",
  "sessionRating.ratingLabel": "Score",
  "sessionRating.saveError": "Error saving session ratings.",
  "sessionRating.saveRatings": "Save Ratings",
  "sessionRating.savedSuccess": "Training session ratings saved successfully.",
  "sessionRating.subtitle": "Rate performance of called-up players (0 to 10)",
  "sessionRating.title": "Session Rating",
  "settings.teamIdentity": "Team Identity",
  "shot.badge_decisive": "DECISIVE",
  "shot.badge_normal": "NORMAL",
  "shot.blocked": "Finalização Bloqueada",
  "shot.cancel": "Cancel",
  "shot.comfort": "Shooter Comfort",
  "shot.comfort_comfortable": "Comfortable",
  "shot.comfort_pressed": "Pressed",
  "shot.comfort_very_pressed": "High Pressure",
  "shot.confirm": "Record Shot",
  "shot.diff_decisive": "Decisive",
  "shot.diff_normal": "Normal",
  "shot.difficulty": "Save Difficulty",
  "shot.goal": "Gol Marcado",
  "shot.missed": "Finalização para Fora",
  "shot.playType": "Play Type",
  "shot.playType_balon_parado": "Set Piece",
  "shot.playType_contra": "Counter Attack",
  "shot.playType_jugada": "Open Play",
  "shot.playType_penalti": "Penalty",
  "shot.result": "Shot Result",
  "shot.result_bloqueado": "Blocked",
  "shot.result_fuera": "Missed",
  "shot.result_gol": "Goal",
  "shot.result_parada": "Save",
  "shot.saved": "Finalização Defendida",
  "shot.step1": "1. Result",
  "shot.step2": "2. Difficulty",
  "shot.step3": "3. Comfort",
  "shot.team": "Team",
  "shot.team_own": "Own",
  "shot.team_rival": "Opponent",
  "shot.title": "Record Shot with Context",
  "shot.zone": "Shot Zone",
  "shot.zone_inside_center": "Center (Box)",
  "shot.zone_inside_left": "Left Wing (Box)",
  "shot.zone_inside_right": "Right Wing (Box)",
  "shot.zone_outside_center": "Center (Outside)",
  "shot.zone_outside_left": "Left Wing (Outside)",
  "shot.zone_outside_right": "Right Wing (Outside)",
  "shot.zone_penalty": "Penalty Spot",
  "spell.addToDictionary": "Add to dictionary",
  "spell.allCorrect": "No spelling issues",
  "spell.ignore": "Ignore",
  "spell.missingAccent": "Missing accent",
  "spell.noSuggestions": "No direct suggestions",
  "spell.observations": "{count} spelling observation",
  "spell.observationsPlural": "{count} spelling observations",
  "spell.recommended": "Suggestions:",
  "spell.title": "Spelling & Grammar",
  "spell.typo": "Typo",
  "spell.unrecognized": "Unrecognized word",
  "staff.cancelInvitation": "Cancel invitation",
  "staff.changeRole": "Change Role:",
  "staff.copied": "Copied!",
  "staff.copy": "Copy",
  "staff.copyCode": "Copy Code",
  "staff.copyLink": "Copy Link",
  "staff.copyLinkDesc": "Copy and send this link to the staff member so they can join the team:",
  "staff.createdDate": "Created: {date}",
  "staff.generateLink": "⚡ Generate Link / Code",
  "staff.inviteGenerated": "Invitation Generated!",
  "staff.inviteLinkCopied": "Invitation link copied.",
  "staff.inviteModalDesc": "Enter the email address and select the role. The user will be able to access and collaborate in real time.",
  "staff.inviteModalTitle": "Invite Coaching Staff Member",
  "staff.inviteStaffBtn": "Invite Staff ({count}/{limit})",
  "staff.pendingInvitations": "Pending Invitations ({count})",
  "staff.realtimeSync": "Team: {team} · Real-time sync",
  "staff.remove": "Remove",
  "staff.removeConfirm": "Are you sure you want to remove {name} from the coaching staff?",
  "staff.role.admin": "Head Coach (Admin)",
  "staff.role.analyst": "Tactical Analyst",
  "staff.role.assistant": "Assistant / 3rd Coach",
  "staff.role.assistantCoach": "Assistant Coach",
  "staff.role.coach": "Assistant Coach",
  "staff.role.collaborator": "Staff Collaborator",
  "staff.role.coordinator": "Academy Director",
  "staff.role.delegate": "Team Delegate",
  "staff.role.doctor": "Team Doctor",
  "staff.role.fitness_coach": "Fitness Coach",
  "staff.role.goalkeeperCoach": "Goalkeeper Coach",
  "staff.role.headCoach": "Head Coach",
  "staff.role.physicalTrainer": "Fitness Coach",
  "staff.role.physio": "Physiotherapist",
  "staff.role.player": "Player",
  "staff.role.scout": "Scout",
  "staff.roleAssistantCoach": "Auxiliar Técnico",
  "staff.roleDesc.admin": "Full control: team management, members, matches, sessions, health, and tactics.",
  "staff.roleDesc.analyst": "Real-time Live Stats recording and analysis, reports, and analytics.",
  "staff.roleDesc.assistant": "Live Stats recording, attendance tracking, and session support.",
  "staff.roleDesc.coach": "Match editing, lineups, sessions, whiteboard, planning, and attendance.",
  "staff.roleDesc.fitness_coach": "Physical preparation, training loads, fitness tests, and athletic status.",
  "staff.roleDesc.physio": "Access and editing of medical history, injuries, fitness/wellness tests, and attendance.",
  "staff.roleDesc.player": "Read-only access to individual profile, sessions, and calendar.",
  "staff.roleDoctor": "Médico",
  "staff.roleFitnessCoach": "Preparador Físico",
  "staff.roleGoalkeeperCoach": "Treinador de Goleiros",
  "staff.roleHeadCoach": "Treinador Principal",
  "staff.roleLabel": "Role in Coaching Staff",
  "staff.rolePhysio": "Fisioterapeuta",
  "staff.roleScout": "Olheiro / Analista",
  "staff.sendInvite": "Send Invitation",
  "staff.shareCodeDesc": "Share this code so players or parents can join from the Portal (/join-team).",
  "staff.shareLink": "Share Link",
  "staff.shareNative": "📲 Share Link (WhatsApp / Apps)",
  "staff.sixDigitCode": "6-digit code:",
  "staff.staffTitle": "Coaching Staff & Collaborators",
  "staff.tab.active": "Comissão Ativa",
  "staff.tab.invites": "Convites",
  "staff.uniqueCodeTitle": "Unique Code for Players & Families",
  "staff.you": "(You)",
  "staffHeredado.badgeActive": "PRO features active via {ownerName}'s plan",
  "staffHeredado.badgeActiveShort": "Inherited Plan ({ownerName})",
  "staffHeredado.gracePeriodBanner": "Subscription Notice: The owner's plan has changed. The team will enter restricted mode in {days} days. Upgrade to PRO to maintain full access.",
  "staffHeredado.gracePeriodBlocked": "Restricted Access: The team grace period has expired. The owner must reactivate their PRO plan to restore full staff privileges.",
  "staffHeredado.restrictedFeatureStaff": "This feature requires the team to have an active PRO plan from the owner.",
  "staffHeredado.transferError": "Error transferring team ownership.",
  "staffHeredado.transferLimitExceeded": "This user already owns a team on their Free plan. They must upgrade to PRO to accept ownership of this team.",
  "staffHeredado.transferSuccess": "Team ownership transferred successfully to {userName}.",
  "staffInvite.cardSubtitle": "Exclusive code to link assistants, fitness coaches, and analysts to technical staff.",
  "staffInvite.cardTitle": "ACCESS CODE FOR COACHES / STAFF",
  "staffInvite.codeCopied": "Staff code copied",
  "staffInvite.copyCode": "Copy Code",
  "staffInvite.copyLink": "Copy Link",
  "staffInvite.downloadQr": "Download QR Image",
  "staffInvite.emailLabel": "Collaborator email address:",
  "staffInvite.inputPlaceholder": "e.g. ABC123 or STF-ABC123",
  "staffInvite.inviteEmail": "Invite via Email",
  "staffInvite.joinBtn": "JOIN TEAM",
  "staffInvite.joinSubtitle": "If you were invited by the head coach, enter your code here.",
  "staffInvite.joinTitle": "ACCESS CODE FOR COACHES / STAFF",
  "staffInvite.linkCopied": "Staff link copied",
  "staffInvite.messageLabel": "Invitation message:",
  "staffInvite.modalTitle": "Invite Technical Staff Member",
  "staffInvite.qrCopied": "Link copied",
  "staffInvite.qrModal": "View Staff QR",
  "staffInvite.qrModalTitle": "Staff QR Invitation Code",
  "staffInvite.qrSubtitle": "The invited coach can scan this QR code with their mobile device to join the staff:",
  "staffInvite.roleLabel": "Assigned role:",
  "staffInvite.sendBtn": "Send Invitation",
  "staffInvite.sendSuccess": "Invitation sent successfully.",
  "staffInvite.shareLink": "Share Link",
  "staffJoin.assignedRole": "Assigned Role:",
  "staffJoin.btnSubmit": "Search and Join",
  "staffJoin.confirmJoin": "CONFIRM AND JOIN STAFF",
  "staffJoin.errors.invalidCode": "Invalid or expired staff code. Contact the head coach.",
  "staffJoin.inputPlaceholder": "e.g. STF-ABC123 or ABC123",
  "staffJoin.linkPlaceholder": "https://mister11.com/join-staff?code=ABC123",
  "staffJoin.orPasteLink": "Have an invite link? Paste it here:",
  "staffJoin.searching": "Validating code in real time...",
  "staffJoin.subtitle": "Enter the 6-character code provided by the head coach or paste your invitation link.",
  "staffJoin.success": "You have successfully joined the Technical Staff!",
  "staffJoin.teamFound": "Team Found:",
  "staffJoin.title": "Join Technical Staff",
  "stats.eventMap.guide": "Spatial distribution of team actions (recoveries, duels, shots, and fouls). Highlights where the team is working, winning duels, or conceding ground on the pitch.",
  "stats.eventMap.pass_insufficient": "Pass network unavailable: At least 5 recorded passes are required to generate tactical passing links. Showing zone event distribution instead.",
  "stats.eventMap.title": "Zone Event Map",
  "stats.passNetwork.guide": "Each node represents a player's average position and line thickness reflects pass volume between teammates. It identifies key passing partnerships and ball circulation dynamics.",
  "stats.theater.close": "Close theater mode",
  "stats.theater.exit_fullscreen": "Exit Fullscreen",
  "stats.theater.fullscreen": "Fullscreen",
  "stats.theater.theater_mode": "Theater Mode",
  "status.none": "Not Selected",
  "swot.add_manual": "Add manual observation",
  "swot.ai_summary_title": "Tactical Summary (AI)",
  "swot.auto_badge": "Rule",
  "swot.btn_generate_ai": "Draft summary with AI",
  "swot.generating_ai": "Drafting with AI...",
  "swot.manual_badge": "Manual",
  "swot.no_items": "No observations recorded for this quadrant.",
  "swot.opportunities": "Opportunities",
  "swot.origin_metric": "Origin metric",
  "swot.rule.central_box_leak": "Defensive vulnerability in the central corridor inside own box.",
  "swot.rule.counter_efficiency": "Constant danger and rapid transitions on counter attacks.",
  "swot.rule.duels_fragility": "Low duel win rate compromising midfield possession control.",
  "swot.rule.duels_superiority": "Territorial dominance and authority in individual duels.",
  "swot.rule.gk_decisive_hero": "Decisive goalkeeping performance with high-merit crucial stops.",
  "swot.rule.gk_high_exertion": "High workload on the goalkeeper due to frequent opponent box entries.",
  "swot.rule.high_attendance_cohesion": "Excellent training attendance consistency and tactical team cohesion.",
  "swot.rule.high_xg_diff": "High attacking creation volume outperforming opponent in clear chances.",
  "swot.rule.late_fatigue": "Goals or shots conceded in the final 15 minutes indicate fatigue.",
  "swot.rule.low_xg_conv": "Chances created with low conversion rate, requiring finishing adjustments.",
  "swot.rule.rival_high_comfort": "Opponent shoots with excessive comfort without immediate pressure.",
  "swot.rule.set_piece_threat": "Chances conceded on set pieces require tighter defensive marking.",
  "swot.rule.wing_defense_solid": "Effective control of wide channels minimizing opponent danger.",
  "swot.strengths": "Strengths",
  "swot.threats": "Threats",
  "swot.title": "Traceable SWOT Matrix",
  "swot.weaknesses": "Weaknesses",
  "team.squadCount.one": "{count} player in squad",
  "team.squadCount.other": "{count} players in squad",
  "team.title": "My Team",
  "teamMembers.admin_only_remove": "Only the Head Coach (Admin) can remove team members.",
  "teamMembers.already_member": "This user is already a member of the coaching staff.",
  "teamMembers.invite_cancelled": "Invitation cancelled.",
  "teamMembers.invite_generated": "Invitation link and code generated successfully.",
  "teamMembers.member_removed": "Member removed from coaching staff.",
  "teamMembers.role_updated": "Role updated to {role}.",
  "teamQr.codeCopiedToast": "Team code copied to clipboard",
  "teamQr.copied": "Copied",
  "teamQr.copyCode": "Copy Code",
  "teamQr.downloadImage": "Download QR Image",
  "teamQr.linkCopiedToast": "Invitation link copied to clipboard",
  "teamQr.modalTitle": "Team QR Code and Access Link",
  "teamQr.scanInstructions": "Show this QR code to your players or share the direct link so they can join the team:",
  "teamQr.shareLink": "Share Link",
  "teamQr.teamCodeLabel": "Access Code:",
  "test.answeringAll": "Please answer all questionnaire items.",
  "test.auto.acsi28.cat": "Coping and Pressure",
  "test.auto.acsi28.desc": "Assesses your ability to stay calm under errors, handle pressure and focus during key match moments.",
  "test.auto.acsi28.name": "ACSI-28 (Athletic Coping Skills)",
  "test.auto.acsi28.q1": "I stay calm and keep a positive mindset even when the score is down.",
  "test.auto.acsi28.q2": "If I make a mistake or lose the ball, I let it go quickly and focus on the next play.",
  "test.auto.acsi28.q3": "I remain focused on the game despite shouting or outside noise.",
  "test.auto.acsi28.q4": "I can focus fully on the tactical task requested by the head coach.",
  "test.auto.acsi28.q5": "I feel total confidence in my abilities before stepping onto the pitch.",
  "test.auto.acsi28.q6": "In crunch time or decisive minutes I play freely without freezing.",
  "test.auto.acsi28.q7": "I accept coach feedback knowing it helps me develop as a player.",
  "test.auto.acsi28.q8": "I adapt quickly if my coach changes my position or role during the game.",
  "test.auto.acsi28.short": "ACSI-28",
  "test.auto.geq.cat": "Team Spirit and Dressing Room",
  "test.auto.geq.desc": "Assesses squad unity, peer communication, and belonging within the squad.",
  "test.auto.geq.name": "GEQ (Group Environment Questionnaire)",
  "test.auto.geq.q1": "Everyone in the dressing room pulls together toward common targets.",
  "test.auto.geq.q2": "We encourage and back each other up when someone makes a mistake.",
  "test.auto.geq.q3": "There is a healthy, positive atmosphere and true fellowship off the pitch.",
  "test.auto.geq.q4": "I feel completely valued and integrated in this squad.",
  "test.auto.geq.short": "GEQ Cohesion",
  "test.auto.goals.cat": "Goals and Focus",
  "test.auto.goals.desc": "Evaluates how you plan technical and physical goals to improve week after week.",
  "test.auto.goals.name": "Goal Setting Scale",
  "test.auto.goals.q1": "I clearly know which technical or fitness skills to sharpen this month.",
  "test.auto.goals.q2": "I give extra effort on drills that challenge me the most.",
  "test.auto.goals.q3": "I reflect on matches and drills to see what I can improve next time.",
  "test.auto.goals.short": "Individual Goals",
  "test.auto.mhc.cat": "Psychosocial Well-Being",
  "test.auto.mhc.desc": "Assesses joy in playing, fulfillment, and athletic progression.",
  "test.auto.mhc.name": "MHC-SF (Mental Health Continuum)",
  "test.auto.mhc.q1": "I truly enjoy and feel happy every time I show up to practice or play.",
  "test.auto.mhc.q2": "I feel playing sports shapes me into a better person and builds discipline.",
  "test.auto.mhc.q3": "I enjoy a trusting and respectful relationship with the coaching staff.",
  "test.auto.mhc.short": "Emotional Well-Being",
  "test.auto.mtq10.cat": "Mental Toughness",
  "test.auto.mtq10.desc": "Measures your grit, determination, and how you turn challenging moments into growth opportunities.",
  "test.auto.mtq10.name": "MTQ-10 (Mental Toughness)",
  "test.auto.mtq10.q1": "I maintain emotional control when referee calls or plays do not go as planned.",
  "test.auto.mtq10.q2": "I stick to workouts and physical sessions even on low-motivation days.",
  "test.auto.mtq10.q3": "I view tough opponents and challenges as chances to prove my quality.",
  "test.auto.mtq10.q4": "I trust my capability to bounce back from slumps or bench time.",
  "test.auto.mtq10.q5": "I never give up until the referee blows the final whistle.",
  "test.auto.mtq10.short": "MTQ Toughness",
  "test.auto.rpe.cat": "Physical Load and Exertion",
  "test.auto.rpe.desc": "Log your perceived exertion after your latest practice or match using the validated Borg 1-10 scale.",
  "test.auto.rpe.name": "RPE (Borg CR-10 Scale)",
  "test.auto.rpe.q1": "What level of exertion or physical intensity did you experience in your last session or match?",
  "test.auto.rpe.short": "RPE Exertion",
  "test.backToCatalog": "Back to test catalog",
  "test.category.aerobic": "Aeróbico e Resistência",
  "test.category.anaerobic": "Potência Anaeróbica",
  "test.category.flexibility": "Flexibilidade",
  "test.category.speed": "Velocidade e Sprint",
  "test.category.strength": "Força e Potência",
  "test.completedBadge": "Completed",
  "test.completedSuccess": "Test {name} completed successfully! ({pct}%)",
  "test.dim.belonging": "Belonging",
  "test.dim.challenge": "Challenge",
  "test.dim.coachability": "Coachability",
  "test.dim.commitment": "Commitment",
  "test.dim.concentration": "Concentration",
  "test.dim.confidence": "Self-Confidence",
  "test.dim.coping": "Coping",
  "test.dim.emotionalControl": "Emotional Control",
  "test.dim.goalClarity": "Goal Clarity",
  "test.dim.groupSupport": "Group Support",
  "test.dim.perceivedEffort": "Perceived Exertion",
  "test.dim.perseverance": "Perseverance",
  "test.dim.purpose": "Purpose",
  "test.dim.selfAnalysis": "Self-Analysis",
  "test.dim.selfOvercoming": "Self-Improvement",
  "test.dim.socialCohesion": "Social Cohesion",
  "test.dim.sportsJoy": "Sports Enjoyment",
  "test.dim.staffTrust": "Staff Trust",
  "test.dim.taskCohesion": "Task Cohesion",
  "test.dim.underPressure": "Peak Performance under Pressure",
  "test.dimension": "Dimension",
  "test.errorSaving": "Error saving test. Please try again.",
  "test.finishAndSend": "FINISH AND SEND TO COACH",
  "test.initialEvaluationRegistered": "Initial evaluation recorded",
  "test.lastResult": "Last result",
  "test.of": "of",
  "test.opt.agree": "Agree",
  "test.opt.almostAlways": "Almost always",
  "test.opt.almostNever": "Almost never",
  "test.opt.always": "Always",
  "test.opt.disagree": "Disagree",
  "test.opt.little": "Slightly agree",
  "test.opt.mostTimes": "Most of the time",
  "test.opt.never": "Never",
  "test.opt.notAtAll": "Not at all agree",
  "test.opt.often": "Often",
  "test.opt.quite": "Moderately agree",
  "test.opt.quiteAgree": "Moderately agree",
  "test.opt.rarely": "Rarely",
  "test.opt.rpe1": "1 - Very light (recovery)",
  "test.opt.rpe10": "10 - Maximum effort (absolute peak)",
  "test.opt.rpe2": "2 - Light (comfortable)",
  "test.opt.rpe3": "3 - Moderate (steady aerobic)",
  "test.opt.rpe4": "4 - Somewhat hard (feeling fatigue)",
  "test.opt.rpe5": "5 - Hard (noticeable effort)",
  "test.opt.rpe6": "6 - Strenuous",
  "test.opt.rpe7": "7 - Very hard (high intensity)",
  "test.opt.rpe8": "8 - Very hard + (near limit)",
  "test.opt.rpe9": "9 - Exhausting",
  "test.opt.sometimes": "Sometimes",
  "test.opt.somewhatDisagree": "Slightly agree",
  "test.opt.stronglyAgree": "Strongly agree",
  "test.opt.stronglyDisagree": "Strongly disagree",
  "test.previous": "Previous",
  "test.question": "Question",
  "test.questionProgress": "Question {current} of {total}",
  "test.questionsCount": "{count} questions",
  "test.repeatTest": "Retake Test",
  "test.retakeTest": "Retake Questionnaire",
  "test.saveAnswers": "Save & Finish",
  "test.saving": "Saving...",
  "test.startTest": "Start Questionnaire",
  "test.successSaved": "Test completed and saved to your file.",
  "test.tabSubtitle": "Complete these questionnaires from your mobile to boost mindset, focus, and team cohesion.",
  "test.tabTitle": "Tests & Self-Assessments",
  "test.timeEstimate": "~{minutes} min",
  "tests.alertResetConfirm": "Are you sure you want to reset the season data?",
  "tests.attention": "⚠️ ATTENTION",
  "tests.catalogPhysical": "Test Catalog: PHYSICAL",
  "tests.catalogPsychosocial": "Test Catalog: PSYCHOSOCIAL",
  "tests.confirm_delete": "Confirm deletion",
  "tests.confirm_season_reset": "Reset Season",
  "tests.createTest": "+ Create Test",
  "tests.demoData": "🎯 Demo Data",
  "tests.demoDataTooltip": "Inserts mock evaluations to preview chart functionality",
  "tests.demoSuccess": "Demo data loaded successfully!",
  "tests.error": "Error",
  "tests.exportReport": "Export Report",
  "tests.insert_demo": "Insert demo data",
  "tests.matrix.exportTeamReport": "Export Team Report",
  "tests.matrix.initialEval": "Initial Eval",
  "tests.matrix.latestEval": "Latest Eval",
  "tests.matrix.number": "Number",
  "tests.matrix.player": "Player",
  "tests.matrix.previousEval": "Previous Eval",
  "tests.matrix.progress": "Progress",
  "tests.matrix.title": "PLANNING MATRIX",
  "tests.metricUnit": "Metric: ",
  "tests.modal.cancel": "CANCEL",
  "tests.modal.confirm": "OK",
  "tests.modal.downloadTemplate": "Download Data Collection Template",
  "tests.modal.execution": "Execution:",
  "tests.modal.executionProtocol": "EXECUTION PROTOCOL",
  "tests.modal.goToRecord": "Go to Record Results",
  "tests.modal.measurement": "Measurement:",
  "tests.modal.noProtocol": "No detailed protocol specified for this test.",
  "tests.modal.objective": "Objective:",
  "tests.modal.objectiveDesc": "OBJECTIVE & DESCRIPTION",
  "tests.modal.recordTitle": "Record:",
  "tests.modal.rfefBadge": "Official RFEF Benchmark (Male & Female Percentiles)",
  "tests.modal.rfefTooltip": "Source: Real Federación Española de Fútbol (RFEF) - Physical Fitness Standards in Youth Female Football (Standing Long Jump).",
  "tests.modal.unit": "Unit of measurement:",
  "tests.modal.unitLabel": "Unit: ",
  "tests.newModal.category": "Specific Category",
  "tests.newModal.categoryPlaceholder": "e.g. Endurance, Psychology...",
  "tests.newModal.desc": "Short Description",
  "tests.newModal.descPlaceholder": "Test summary",
  "tests.newModal.name": "Test Name",
  "tests.newModal.namePlaceholder": "e.g. Squat 1RM",
  "tests.newModal.physical": "Physical",
  "tests.newModal.protocol": "Complete Execution Protocol",
  "tests.newModal.protocolPlaceholder": "Exact steps on how the test is performed on field...",
  "tests.newModal.psychosocial": "Psychosocial",
  "tests.newModal.socioemotional": "Socio-emotional",
  "tests.newModal.tactical": "Tactical",
  "tests.newModal.title": "New Test",
  "tests.newModal.type": "Test Type",
  "tests.newModal.unit": "Unit of Measurement",
  "tests.newModal.unitPlaceholder": "e.g. kg, sec, pts",
  "tests.record": "RECORD",
  "tests.resetSeason": "🗑️ Reset Season",
  "tests.resetSeasonTooltip": "Deletes all player evaluation data to start a new season",
  "tests.resources.drillDatabase": "Exercises",
  "tests.resources.myTeam": "My Squad",
  "tests.resources.seasonReport": "Season Report",
  "tests.resources.tacticalLibrary": "Tactical Board",
  "tests.resources.tacticalTest": "Tactical Test",
  "tests.resources.teamChat": "Team Chat",
  "tests.resources.title": "Resources & Tools",
  "tests.rpe.cancel": "CANCEL",
  "tests.rpe.save": "SAVE RPE",
  "tests.saveResults": "Save Results",
  "tests.success": "Success",
  "tests.tab.comparativa": "Comparison",
  "tests.tab.fisicos": "Physical Tests",
  "tests.tab.historial": "History",
  "tests.tab.prevencion": "Prevention & Health",
  "tests.tab.psicosociales": "Psychosocial",
  "tests.template": "TEMPLATE",
  "tests.title": "EVALUATION & TESTS",
  "tests.validation": "Validation",
  "tests.wellness.save": "Save Evaluation",
  "wellness.fatigue": "Nível de Fadiga",
  "wellness.mood": "Humor / Disposição",
  "wellness.rpe.cancel": "CANCEL",
  "wellness.rpe.desc": "Record how {name} perceived the effort.",
  "wellness.rpe.durationLabel": "Session duration (minutes)",
  "wellness.rpe.levelLabel": "Exertion Level (RPE 1-10)",
  "wellness.rpe.save": "SAVE RPE",
  "wellness.rpe.scaleMax": "10 - Maximum effort",
  "wellness.rpe.scaleMin": "1 - Very light",
  "wellness.rpe.title": "Rate of Perceived Exertion (RPE)",
  "wellness.rpe.trainingLoad": "Training Load (RPE × Duration):",
  "wellness.sleep": "Qualidade do Sono",
  "wellness.soreness": "Dor Muscular",
  "wellness.stress": "Nível de Estresse",
  "whiteboard.exportError": "Error exporting MP4 video. Please try again.",
  "whiteboard.exportRetry": "Retry export",
  "whiteboard.exportSuccess": "MP4 video exported successfully.",
  "whiteboard.exportingFrame": "Exporting frame {current} of {total}...",
  "xg.box_center": "Central Box",
  "xg.box_wings": "Lateral Box",
  "xg.decisive_pct": "Decisive Success %",
  "xg.decisive_saves": "Decisive Saves",
  "xg.demanding_match": "Demanding Match",
  "xg.desc": "Statistical goal probability based on zone, comfort, and play type.",
  "xg.exposure_map": "Defensive Exposure Map",
  "xg.gk_exertion": "GK Exertion Index",
  "xg.label": "Expected Goals (xG)",
  "xg.normal_match": "Controlled Exertion",
  "xg.normal_saves": "Normal Saves",
  "xg.outside_box": "Outside Box",
  "xg.own_xg": "Own xG",
  "xg.penalty_box": "Penalty",
  "xg.rival_comfort": "Opponent Comfort",
  "xg.rival_xg": "Opponent xG",
  "xg.save_pct": "Save Effectiveness %",
  "xg.title": "xG-Lite Model & Exposure",
  "xg.totalTeam": "xG Total do Time",
  "xg.total_saves": "Total Saves",
  "clinical.fallbackChip": "clinical content in Spanish",
  "landing.footer.languages": "Languages",
  "landing.footer.rights": "All rights reserved.",
  "landing.hero.badge": "THE COACH'S DIGITAL BRAIN",
  "landing.hero.btnPrimary": "START 7-DAY FREE TRIAL",
  "landing.hero.btnSecondary": "COMPARE PLANS",
  "landing.hero.desc": "Interactive tactical whiteboard, live recording with FIFA 105:68 regulatory pitch proportion, AI injury prevention, validated psychometric tests, and official PDF match sheets.",
  "landing.hero.title_highlight": "professional standard",
  "landing.hero.title_part1": "Elevate your football methodology to a",
  "landing.nav.login": "LOG IN",
  "landing.nav.selectLang": "Select language",
  "landing.nav.themeToggle": "Toggle theme",
  "landing.preview.title": "Mister11 Tactical Board · Live Pitch & Pieces",
  "landing.trust.noCard": "No credit card needed",
  "landing.trust.platforms": "Web, PWA & Android",
  "landing.trust.trial": "7 days full trial",
  "pricing.toggle.monthly": "Monthly",
  "pricing.toggle.season": "Season Pass (Recommended)",
  "pdf.trainingSheet": "TRAINING SESSION SHEET",
  "pdf.date": "DATE",
  "pdf.time": "TIME",
  "pdf.duration": "DURATION",
  "pdf.intensity": "INTENSITY",
  "pdf.category": "CATEGORY",
  "pdf.material": "EQUIPMENT",
  "pdf.blocks": "BLOCKS",
  "pdf.mainTacticalDiagram": "MAIN TACTICAL DIAGRAM",
  "pdf.trainingBlocks": "TRAINING BLOCKS",
  "pdf.convocation": "SQUAD CALL-UP",
  "pdf.postSessionNotes": "POST-SESSION NOTES",
  "pdf.notesEmpty": "No notes recorded",
  "pdf.myTeam": "My Team",
  "pdf.footerBrand": "Mister11 Platform - mister11.app",
  "pdf.pageOf": "Page {cur} of {total}",
  "pdf.objectivePrefix": "Objective: ",
  "player.greet.hello": "Hello!",
  "player.join": "Join with Code",
  "player.ach.unlocked": "UNLOCKED",
  "player.tier.bronze": "Bronze",
  "player.tier.silver": "Silver",
  "player.tier.gold": "Gold",
  "player.period.biweekly": "This fortnight",
  "player.profile.dominantFoot": "Dominant foot: {foot}",
  "player.profile.rightFoot": "Right",
  "player.profile.leftFoot": "Left",
  "player.profile.ambidextrous": "Ambidextrous",
  "player.consent.signEdit": "Sign / Edit Consent",
  "player.auth.switchToCoach": "Switch to Coach Mode",
  "player.auth.logout": "Log Out",
  "player.auth.deleteAccount": "Delete Account & Data (GDPR)",
  "player.games.healthyTraining": "HEALTHY TRAINING",
  "player.games.homeChallenges": "Home Challenges",
  "player.games.reactionSpeed": "REACTION SPEED",
  "player.games.workingMemory": "WORKING MEMORY",
  "player.games.tacticalReading": "TACTICAL READING",
  "player.games.play": "PLAY",
  "player.wellness.dailyCheckin": "DAILY WELLNESS CHECK-IN",
  "player.wellness.saveCheckin": "SUBMIT DAILY CHECK-IN",
  "player.wellness.updateCheckin": "UPDATE GENERAL STATUS",
  "player.wellness.medicalHistory": "Medical History & Injuries",
  "player.wellness.recordInjury": "RECORD INJURY OR DISCOMFORT",
  "player.plans.individualPlans": "Individual Training Plans",
  "player.plans.evolutionConstancy": "EVOLUTION & CONSISTENCY",
  "player.plans.activeCount": "{count} Active Plans",
  "player.plans.allUpToDate": "All up to date with your plans!",
  "player.ach.tabs.vitrina": "Showcase",
  "player.ach.tabs.games": "Games & Challenges",
  "player.ach.tabs.ranking": "Ranking",
  "player.schedule.prevMonth": "Previous month",
  "player.schedule.nextMonth": "Next month",
  "player.schedule.calledUpTitle": "Called up for the match!",
  "player.schedule.reserveTitle": "Standby / Reserve list",
  "player.schedule.notCalledTitle": "Not called up for this match",
  "player.schedule.played": "played",
  "player.schedule.sheetClosed": "Official match sheet closed",
  "player.schedule.officialMinutes": "Official minutes: {min}'",
  "player.schedule.dnp": "Did not play (DNP)",
  "player.schedule.parentPrompt": "Will {name} attend this event?",
  "player.schedule.playerPrompt": "Will you attend this session?",
  "player.schedule.officialRecorded": "Official attendance recorded by coaching staff",
  "player.schedule.pendingVerificationDesc": "Session held, pending coach verification",
  "player.schedule.parentTrainingPrompt": "Will {name} attend this training session?",
  "player.schedule.playerTrainingPrompt": "Will you attend this training session?",
  "player.schedule.photosCaptures": "Photos & Captures",
  "player.schedule.noEventsDesc": "Your coach has not scheduled sessions or matches for this month yet.",
  "player.plans.active": "Active",
  "player.plans.progressionHabit": "PROGRESSION & HABIT",
  "player.plans.activePlan": "Active Plan",
  "player.plans.activePlans": "Active Plans",
  "player.plans.youth": "Youth",
  "player.plans.monitoring": "Monitoring",
  "player.plans.loading": "Loading your training plans...",
  "player.plans.upToDate": "Up to date with your preparation!",
  "player.plans.techRoutine": "Technical Routine",
  "player.plans.defaultPlanTitle": "Individual Training Plan",
  "player.plans.coachInstructions": "Coach Instructions:",
  "player.plans.todayExercises": "Today's Exercises:",
  "player.plans.doneCount": "done",
  "player.plans.markPending": "Mark as pending",
  "player.plans.viewGuide": "View technical guide",
  "player.plans.guide": "Guide",
  "player.plans.notAgeSafe": "Not suitable for your age",
  "player.plans.ageSafeTooltip": "This exercise requires a minimum age of {minAge} years for biomechanical safety.",
  "player.stats.evaluation": "Evaluation",
  "player.stats.general": "General",
  "player.stats.session": "Session",
  "player.stats.starter": "Starter",
  "player.stats.sub": "Sub",
  "player.stats.pendingSheet": "Pending official sheet",
  "player.stats.coachRating": "Coach's rating",
  "player.stats.attitude": "Attitude",
  "player.stats.hitsVsMisses": "Hits vs Misses",
  "player.stats.shotsOnTarget": "Shots on target / total",
  "player.stats.duelsWon": "Duels won / total",
  "player.stats.recoveriesLosses": "Recoveries vs Losses",
  "player.stats.fouls": "fouls",
  "player.stats.bestStat": "Your best stat this match",
  "player.stats.youVsAverage": "You vs Your Season Average",
  "player.stats.areasPending": "Areas pending measurement",
  "player.stats.activeDiscomfort": "Active discomfort",
  "player.stats.available100": "100% Available",
  "player.stats.dailyProgression": "Daily Check-in Progression (Last 7 days)",
  "player.stats.pain": "Pain",
  "player.stats.ok": "OK",
  "player.stats.cleanSheet": "Clean Sheet",
  "player.chat.defaultPlayerName": "this player",
  "player.home.defaultRole": "Player",
  "player.home.defaultCrack": "Star",
  "player.home.calledUpSquad": "You are in the official match squad!",
  "player.home.defaultLocation": "Training Ground",
  "stats.singleMatch": "1 match",
  "stats.partidos": "matches",
  "player.home.staffAuthor": "Coaching Staff",
  "player.home.recent": "Recent",
  "player.banner.perfProfile": "PERFORMANCE PROFILE",
  "player.banner.noTestData": "No test data yet",
  "player.banner.perfMedal": "PERFORMANCE MEDAL",
  "player.profile.securityReauth": "For security reasons, you must log out and sign in again before deleting your account.",
  "player.profile.deleteAccountError": "Could not delete account. Please contact us or try again after restarting session.",
  "player.profile.matchesPlayedShort": "MP",
  "player.profile.defaultCategory": "Youth",
  "player.profile.accountFallback": "Player Account",
  "player.wellness.saving": "Saving...",
  "player.consent.parentPlaceholder": "e.g. Charles Smith Perez",
  "player.settings.notifDenied": "Notification permissions denied.",
  "player.settings.remindersActivated": "Reminders activated.",
  "player.settings.languageUpdated": "Language updated",
  "player.settings.confirmLogout": "Do you want to log out?",
  "player.settings.toggleTheme": "Toggle dark/light theme",
  "player.settings.toggleNotif": "Toggle notifications",
  "test.name.cooper": "Cooper Test",
  "test.cat.endurance": "Physical · Endurance",
  "test.name.navette": "Beep Test (Course Navette)",
  "test.name.sprint10": "10m Sprint",
  "test.cat.speed": "Physical · Speed",
  "test.name.sprint30": "30m Sprint",
  "test.name.ttest": "T-Test Agility",
  "test.cat.agility": "Physical · Agility",
  "test.name.cmj": "CMJ Jump",
  "test.cat.power": "Physical · Power",
  "test.name.cones": "Cone Dribbling",
  "test.cat.ballControl": "Technical · Ball Control",
  "test.name.shooting": "Goal Shooting",
  "test.cat.accuracy": "Technical · Accuracy",
  "test.name.acsi28": "ACSI-28 Coping Skills",
  "test.cat.pressure": "Mental · Pressure",
  "test.name.mtq10": "MTQ-10 Mental Toughness",
  "test.cat.resilience": "Mental · Resilience",
  "test.name.goals": "Goal Setting Scale",
  "test.cat.goals": "Mental · Goals",
  "test.name.leadership": "Leadership & Communication",
  "test.cat.leadership": "Mental · Leadership",
  "test.name.geq": "GEQ Team Cohesion",
  "test.cat.cohesion": "Social · Cohesion",
  "test.name.mhc": "MHC-SF Mental Well-being",
  "test.cat.wellbeing": "Mental · Well-being",
  "test.name.emotions": "Emotional Awareness",
  "test.cat.emotions": "Mental · Emotions",
  "player.stats.pendingOfficialSheet": "Pending official confirmation — Stats will appear once the match sheet is closed.",
  "stats.goles": "Goals",
  "stats.asistencias": "Assists",
  "stats.minutos": "Minutes",
  "player.stats.goalsThisMatch": "Goals this match",
  "player.stats.minutesThisMatch": "Minutes this match",
  "player.stats.avgShort": "avg",
  "player.stats.avgLabel": "Avg",
  "player.stats.coachMessage": "Coach's Message",
  "player.stats.discipline": "Discipline",
  "player.stats.lastEval": "Last eval:",
  "player.tab.technical": "Technical",
  "player.tab.tactical": "Tactical",
  "player.stats.trainingRatingDesc": "Rating from coach in training sessions",
  "player.stats.pendingRatings": "Pending ratings",
  "player.stats.noRatingsYet": "No training session ratings yet",
  "player.stats.ratingsInfoDesc": "Your coaching staff can rate performance and leave tactical feedback after every training session from the Sessions module.",
  "player.stats.weeklyWellness": "WEEKLY WELLNESS & RECOVERY",
  "player.stats.last7Days": "Last 7 days",
  "player.stats.sleepQuality": "SLEEP QUALITY",
  "player.stats.energyMood": "ENERGY / MOOD",
  "player.stats.muscleStatus": "MUSCLE STATUS",
  "player.profile.sectionsAria": "Player profile sections",
  "player.banner.viewFullAnalytics": "View full analytics",
  "player.banner.techSummary": "Technical summary",
  "player.banner.renewTests": "Renew questionnaires and tests",
  "player.wellness.synced": "Synced",
  "player.wellness.offlinePending": "Pending sync",
  "games.level.bronce": "Bronze",
  "games.level.plata": "Silver",
  "games.level.oro": "Gold",
  "games.level.diamante": "Diamond",
  "games.level.leyenda": "Legend",
  "games.levelUp": "You leveled up to {level}! (+10 XP)",
  "games.levelCeiling": "You reached the Legend ceiling!",
  "games.g3.opponent": "Opponent",
  "games.g3.teammate": "Teammate",
  "exercise.level": "Level"
};

export default en;
